webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	__webpack_require__(9);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(11);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(13);
	
	var _app = __webpack_require__(14);
	
	var _navbar = __webpack_require__(15);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(17);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(19);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(22);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(24);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _socket = __webpack_require__(26);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _about = __webpack_require__(83);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _welcome = __webpack_require__(86);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _loading = __webpack_require__(89);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _howto = __webpack_require__(92);
	
	var _howto2 = _interopRequireDefault(_howto);
	
	var _train = __webpack_require__(95);
	
	var _train2 = _interopRequireDefault(_train);
	
	var _scores = __webpack_require__(98);
	
	var _scores2 = _interopRequireDefault(_scores);
	
	var _videodemo = __webpack_require__(101);
	
	var _videodemo2 = _interopRequireDefault(_videodemo);
	
	var _experiment = __webpack_require__(104);
	
	var _experiment2 = _interopRequireDefault(_experiment);
	
	var _etcalib = __webpack_require__(107);
	
	var _etcalib2 = _interopRequireDefault(_etcalib);
	
	__webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('videogameApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, 'btford.socket-io', _angularUiRouter2.default, _angularUiBootstrap2.default, _navbar2.default, _footer2.default, _main2.default, _welcome2.default, _about2.default, _loading2.default, _train2.default, _howto2.default, _scores2.default, _videodemo2.default, _experiment2.default, _etcalib2.default, _app3.default, _socket2.default, _util2.default, 'cfp.hotkeys']).service('sharedProperties', function () {
	  var property = "";
	  return {
	    getProperty: function getProperty() {
	      return property;
	    },
	    setProperty: function setProperty(value) {
	      property = value;
	    }
	  };
	}).config(_app.routeConfig);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['videogameApp'], {
	    strictDi: true
	  });
	});

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! 
	 * angular-hotkeys v1.7.0
	 * https://chieffancypants.github.io/angular-hotkeys
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-hotkeys
	 *
	 * Automatic keyboard shortcuts for your angular apps
	 *
	 * (c) 2016 Wes Cruver
	 * License: MIT
	 */
	
	(function() {
	
	  'use strict';
	
	  angular.module('cfp.hotkeys', []).provider('hotkeys', ['$injector', function($injector) {
	
	    /**
	     * Configurable setting to disable the cheatsheet entirely
	     * @type {Boolean}
	     */
	    this.includeCheatSheet = true;
	
	    /**
	     * Configurable setting to disable ngRoute hooks
	     * @type {Boolean}
	     */
	    this.useNgRoute = $injector.has('ngViewDirective');
	
	    /**
	     * Configurable setting for the cheat sheet title
	     * @type {String}
	     */
	
	    this.templateTitle = 'Keyboard Shortcuts:';
	
	    /**
	     * Configurable settings for the cheat sheet header and footer.  Both are HTML, and the header
	     * overrides the normal title if specified.
	     * @type {String}
	     */
	    this.templateHeader = null;
	    this.templateFooter = null;
	
	    /**
	     * Cheat sheet template in the event you want to totally customize it.
	     * @type {String}
	     */
	    this.template = '<div class="cfp-hotkeys-container fade" ng-class="{in: helpVisible}" style="display: none;"><div class="cfp-hotkeys">' +
	                      '<h4 class="cfp-hotkeys-title" ng-if="!header">{{ title }}</h4>' +
	                      '<div ng-bind-html="header" ng-if="header"></div>' +
	                      '<table><tbody>' +
	                        '<tr ng-repeat="hotkey in hotkeys | filter:{ description: \'!$$undefined$$\' }">' +
	                          '<td class="cfp-hotkeys-keys">' +
	                            '<span ng-repeat="key in hotkey.format() track by $index" class="cfp-hotkeys-key">{{ key }}</span>' +
	                          '</td>' +
	                          '<td class="cfp-hotkeys-text">{{ hotkey.description }}</td>' +
	                        '</tr>' +
	                      '</tbody></table>' +
	                      '<div ng-bind-html="footer" ng-if="footer"></div>' +
	                      '<div class="cfp-hotkeys-close" ng-click="toggleCheatSheet()">&#215;</div>' +
	                    '</div></div>';
	
	    /**
	     * Configurable setting for the cheat sheet hotkey
	     * @type {String}
	     */
	    this.cheatSheetHotkey = '?';
	
	    /**
	     * Configurable setting for the cheat sheet description
	     * @type {String}
	     */
	    this.cheatSheetDescription = 'Show / hide this help menu';
	
	    this.$get = ['$rootElement', '$rootScope', '$compile', '$window', '$document', function ($rootElement, $rootScope, $compile, $window, $document) {
	
	      var mouseTrapEnabled = true;
	
	      function pause() {
	        mouseTrapEnabled = false;
	      }
	
	      function unpause() {
	        mouseTrapEnabled = true;
	      }
	
	      // monkeypatch Mousetrap's stopCallback() function
	      // this version doesn't return true when the element is an INPUT, SELECT, or TEXTAREA
	      // (instead we will perform this check per-key in the _add() method)
	      Mousetrap.prototype.stopCallback = function(event, element) {
	        if (!mouseTrapEnabled) {
	          return true;
	        }
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	          return false;
	        }
	
	        return (element.contentEditable && element.contentEditable == 'true');
	      };
	
	      /**
	       * Convert strings like cmd into symbols like ⌘
	       * @param  {String} combo Key combination, e.g. 'mod+f'
	       * @return {String}       The key combination with symbols
	       */
	      function symbolize (combo) {
	        var map = {
	          command   : '\u2318',     // ⌘
	          shift     : '\u21E7',     // ⇧
	          left      : '\u2190',     // ←
	          right     : '\u2192',     // →
	          up        : '\u2191',     // ↑
	          down      : '\u2193',     // ↓
	          'return'  : '\u23CE',     // ⏎
	          backspace : '\u232B'      // ⌫
	        };
	        combo = combo.split('+');
	
	        for (var i = 0; i < combo.length; i++) {
	          // try to resolve command / ctrl based on OS:
	          if (combo[i] === 'mod') {
	            if ($window.navigator && $window.navigator.platform.indexOf('Mac') >=0 ) {
	              combo[i] = 'command';
	            } else {
	              combo[i] = 'ctrl';
	            }
	          }
	
	          combo[i] = map[combo[i]] || combo[i];
	        }
	
	        return combo.join(' + ');
	      }
	
	      /**
	       * Hotkey object used internally for consistency
	       *
	       * @param {array}    combo       The keycombo. it's an array to support multiple combos
	       * @param {String}   description Description for the keycombo
	       * @param {Function} callback    function to execute when keycombo pressed
	       * @param {string}   action      the type of event to listen for (for mousetrap)
	       * @param {array}    allowIn     an array of tag names to allow this combo in ('INPUT', 'SELECT', and/or 'TEXTAREA')
	       * @param {Boolean}  persistent  Whether the hotkey persists navigation events
	       */
	      function Hotkey (combo, description, callback, action, allowIn, persistent) {
	        // TODO: Check that the values are sane because we could
	        // be trying to instantiate a new Hotkey with outside dev's
	        // supplied values
	
	        this.combo = combo instanceof Array ? combo : [combo];
	        this.description = description;
	        this.callback = callback;
	        this.action = action;
	        this.allowIn = allowIn;
	        this.persistent = persistent;
	        this._formated = null;
	      }
	
	      /**
	       * Helper method to format (symbolize) the key combo for display
	       *
	       * @return {[Array]} An array of the key combination sequence
	       *   for example: "command+g c i" becomes ["⌘ + g", "c", "i"]
	       *
	       */
	      Hotkey.prototype.format = function() {
	        if (this._formated === null) {
	          // Don't show all the possible key combos, just the first one.  Not sure
	          // of usecase here, so open a ticket if my assumptions are wrong
	          var combo = this.combo[0];
	
	          var sequence = combo.split(/[\s]/);
	          for (var i = 0; i < sequence.length; i++) {
	            sequence[i] = symbolize(sequence[i]);
	          }
	          this._formated = sequence;
	        }
	
	        return this._formated;
	      };
	
	      /**
	       * A new scope used internally for the cheatsheet
	       * @type {$rootScope.Scope}
	       */
	      var scope = $rootScope.$new();
	
	      /**
	       * Holds an array of Hotkey objects currently bound
	       * @type {Array}
	       */
	      scope.hotkeys = [];
	
	      /**
	       * Contains the state of the help's visibility
	       * @type {Boolean}
	       */
	      scope.helpVisible = false;
	
	      /**
	       * Holds the title string for the help menu
	       * @type {String}
	       */
	      scope.title = this.templateTitle;
	
	      /**
	       * Holds the header HTML for the help menu
	       * @type {String}
	       */
	      scope.header = this.templateHeader;
	
	      /**
	       * Holds the footer HTML for the help menu
	       * @type {String}
	       */
	      scope.footer = this.templateFooter;
	
	      /**
	       * Expose toggleCheatSheet to hotkeys scope so we can call it using
	       * ng-click from the template
	       * @type {function}
	       */
	      scope.toggleCheatSheet = toggleCheatSheet;
	
	
	      /**
	       * Holds references to the different scopes that have bound hotkeys
	       * attached.  This is useful to catch when the scopes are `$destroy`d and
	       * then automatically unbind the hotkey.
	       *
	       * @type {Object}
	       */
	      var boundScopes = {};
	
	      if (this.useNgRoute) {
	        $rootScope.$on('$routeChangeSuccess', function (event, route) {
	          purgeHotkeys();
	
	          if (route && route.hotkeys) {
	            angular.forEach(route.hotkeys, function (hotkey) {
	              // a string was given, which implies this is a function that is to be
	              // $eval()'d within that controller's scope
	              // TODO: hotkey here is super confusing.  sometimes a function (that gets turned into an array), sometimes a string
	              var callback = hotkey[2];
	              if (typeof(callback) === 'string' || callback instanceof String) {
	                hotkey[2] = [callback, route];
	              }
	
	              // todo: perform check to make sure not already defined:
	              // this came from a route, so it's likely not meant to be persistent
	              hotkey[5] = false;
	              _add.apply(this, hotkey);
	            });
	          }
	        });
	      }
	
	
	
	      // Auto-create a help menu:
	      if (this.includeCheatSheet) {
	        var document = $document[0];
	        var element = $rootElement[0];
	        var helpMenu = angular.element(this.template);
	        _add(this.cheatSheetHotkey, this.cheatSheetDescription, toggleCheatSheet);
	
	        // If $rootElement is document or documentElement, then body must be used
	        if (element === document || element === document.documentElement) {
	          element = document.body;
	        }
	
	        angular.element(element).append($compile(helpMenu)(scope));
	      }
	
	
	      /**
	       * Purges all non-persistent hotkeys (such as those defined in routes)
	       *
	       * Without this, the same hotkey would get recreated everytime
	       * the route is accessed.
	       */
	      function purgeHotkeys() {
	        var i = scope.hotkeys.length;
	        while (i--) {
	          var hotkey = scope.hotkeys[i];
	          if (hotkey && !hotkey.persistent) {
	            _del(hotkey);
	          }
	        }
	      }
	
	      /**
	       * Toggles the help menu element's visiblity
	       */
	      var previousEsc = false;
	
	      function toggleCheatSheet() {
	        scope.helpVisible = !scope.helpVisible;
	
	        // Bind to esc to remove the cheat sheet.  Ideally, this would be done
	        // as a directive in the template, but that would create a nasty
	        // circular dependency issue that I don't feel like sorting out.
	        if (scope.helpVisible) {
	          previousEsc = _get('esc');
	          _del('esc');
	
	          // Here's an odd way to do this: we're going to use the original
	          // description of the hotkey on the cheat sheet so that it shows up.
	          // without it, no entry for esc will ever show up (#22)
	          _add('esc', previousEsc.description, toggleCheatSheet, null, ['INPUT', 'SELECT', 'TEXTAREA']);
	        } else {
	          _del('esc');
	
	          // restore the previously bound ESC key
	          if (previousEsc !== false) {
	            _add(previousEsc);
	          }
	        }
	      }
	
	      /**
	       * Creates a new Hotkey and creates the Mousetrap binding
	       *
	       * @param {string}   combo       mousetrap key binding
	       * @param {string}   description description for the help menu
	       * @param {Function} callback    method to call when key is pressed
	       * @param {string}   action      the type of event to listen for (for mousetrap)
	       * @param {array}    allowIn     an array of tag names to allow this combo in ('INPUT', 'SELECT', and/or 'TEXTAREA')
	       * @param {boolean}  persistent  if true, the binding is preserved upon route changes
	       */
	      function _add (combo, description, callback, action, allowIn, persistent) {
	
	        // used to save original callback for "allowIn" wrapping:
	        var _callback;
	
	        // these elements are prevented by the default Mousetrap.stopCallback():
	        var preventIn = ['INPUT', 'SELECT', 'TEXTAREA'];
	
	        // Determine if object format was given:
	        var objType = Object.prototype.toString.call(combo);
	
	        if (objType === '[object Object]') {
	          description = combo.description;
	          callback    = combo.callback;
	          action      = combo.action;
	          persistent  = combo.persistent;
	          allowIn     = combo.allowIn;
	          combo       = combo.combo;
	        }
	
	        // no duplicates please
	        _del(combo);
	
	        // description is optional:
	        if (description instanceof Function) {
	          action = callback;
	          callback = description;
	          description = '$$undefined$$';
	        } else if (angular.isUndefined(description)) {
	          description = '$$undefined$$';
	        }
	
	        // any items added through the public API are for controllers
	        // that persist through navigation, and thus undefined should mean
	        // true in this case.
	        if (persistent === undefined) {
	          persistent = true;
	        }
	        // if callback is defined, then wrap it in a function
	        // that checks if the event originated from a form element.
	        // the function blocks the callback from executing unless the element is specified
	        // in allowIn (emulates Mousetrap.stopCallback() on a per-key level)
	        if (typeof callback === 'function') {
	
	          // save the original callback
	          _callback = callback;
	
	          // make sure allowIn is an array
	          if (!(allowIn instanceof Array)) {
	            allowIn = [];
	          }
	
	          // remove anything from preventIn that's present in allowIn
	          var index;
	          for (var i=0; i < allowIn.length; i++) {
	            allowIn[i] = allowIn[i].toUpperCase();
	            index = preventIn.indexOf(allowIn[i]);
	            if (index !== -1) {
	              preventIn.splice(index, 1);
	            }
	          }
	
	          // create the new wrapper callback
	          callback = function(event) {
	            var shouldExecute = true;
	
	            // if the callback is executed directly `hotkey.get('w').callback()`
	            // there will be no event, so just execute the callback.
	            if (event) {
	              var target = event.target || event.srcElement; // srcElement is IE only
	              var nodeName = target.nodeName.toUpperCase();
	
	              // check if the input has a mousetrap class, and skip checking preventIn if so
	              if ((' ' + target.className + ' ').indexOf(' mousetrap ') > -1) {
	                shouldExecute = true;
	              } else {
	                // don't execute callback if the event was fired from inside an element listed in preventIn
	                for (var i=0; i<preventIn.length; i++) {
	                  if (preventIn[i] === nodeName) {
	                    shouldExecute = false;
	                    break;
	                  }
	                }
	              }
	            }
	
	            if (shouldExecute) {
	              wrapApply(_callback.apply(this, arguments));
	            }
	          };
	        }
	
	        if (typeof(action) === 'string') {
	          Mousetrap.bind(combo, wrapApply(callback), action);
	        } else {
	          Mousetrap.bind(combo, wrapApply(callback));
	        }
	
	        var hotkey = new Hotkey(combo, description, callback, action, allowIn, persistent);
	        scope.hotkeys.push(hotkey);
	        return hotkey;
	      }
	
	      /**
	       * delete and unbind a Hotkey
	       *
	       * @param  {mixed} hotkey   Either the bound key or an instance of Hotkey
	       * @return {boolean}        true if successful
	       */
	      function _del (hotkey) {
	        var combo = (hotkey instanceof Hotkey) ? hotkey.combo : hotkey;
	
	        Mousetrap.unbind(combo);
	
	        if (angular.isArray(combo)) {
	          var retStatus = true;
	          var i = combo.length;
	          while (i--) {
	            retStatus = _del(combo[i]) && retStatus;
	          }
	          return retStatus;
	        } else {
	          var index = scope.hotkeys.indexOf(_get(combo));
	
	          if (index > -1) {
	            // if the combo has other combos bound, don't unbind the whole thing, just the one combo:
	            if (scope.hotkeys[index].combo.length > 1) {
	              scope.hotkeys[index].combo.splice(scope.hotkeys[index].combo.indexOf(combo), 1);
	            } else {
	
	              // remove hotkey from bound scopes
	              angular.forEach(boundScopes, function (boundScope) {
	                var scopeIndex = boundScope.indexOf(scope.hotkeys[index]);
	                if (scopeIndex !== -1) {
	                    boundScope.splice(scopeIndex, 1);
	                }
	              });
	
	              scope.hotkeys.splice(index, 1);
	            }
	            return true;
	          }
	        }
	
	        return false;
	
	      }
	
	      /**
	       * Get a Hotkey object by key binding
	       *
	       * @param  {[string]} [combo]  the key the Hotkey is bound to. Returns all key bindings if no key is passed
	       * @return {Hotkey}          The Hotkey object
	       */
	      function _get (combo) {
	
	        if (!combo) {
	          return scope.hotkeys;
	        }
	
	        var hotkey;
	
	        for (var i = 0; i < scope.hotkeys.length; i++) {
	          hotkey = scope.hotkeys[i];
	
	          if (hotkey.combo.indexOf(combo) > -1) {
	            return hotkey;
	          }
	        }
	
	        return false;
	      }
	
	      /**
	       * Binds the hotkey to a particular scope.  Useful if the scope is
	       * destroyed, we can automatically destroy the hotkey binding.
	       *
	       * @param  {Object} scope The scope to bind to
	       */
	      function bindTo (scope) {
	        // Only initialize once to allow multiple calls for same scope.
	        if (!(scope.$id in boundScopes)) {
	
	          // Add the scope to the list of bound scopes
	          boundScopes[scope.$id] = [];
	
	          scope.$on('$destroy', function () {
	            var i = boundScopes[scope.$id].length;
	            while (i--) {
	              _del(boundScopes[scope.$id].pop());
	            }
	          });
	        }
	        // return an object with an add function so we can keep track of the
	        // hotkeys and their scope that we added via this chaining method
	        return {
	          add: function (args) {
	            var hotkey;
	
	            if (arguments.length > 1) {
	              hotkey = _add.apply(this, arguments);
	            } else {
	              hotkey = _add(args);
	            }
	
	            boundScopes[scope.$id].push(hotkey);
	            return this;
	          }
	        };
	      }
	
	      /**
	       * All callbacks sent to Mousetrap are wrapped using this function
	       * so that we can force a $scope.$apply()
	       *
	       * @param  {Function} callback [description]
	       * @return {[type]}            [description]
	       */
	      function wrapApply (callback) {
	        // return mousetrap a function to call
	        return function (event, combo) {
	
	          // if this is an array, it means we provided a route object
	          // because the scope wasn't available yet, so rewrap the callback
	          // now that the scope is available:
	          if (callback instanceof Array) {
	            var funcString = callback[0];
	            var route = callback[1];
	            callback = function (event) {
	              route.scope.$eval(funcString);
	            };
	          }
	
	          // this takes place outside angular, so we'll have to call
	          // $apply() to make sure angular's digest happens
	          $rootScope.$apply(function() {
	            // call the original hotkey callback with the keyboard event
	            callback(event, _get(combo));
	          });
	        };
	      }
	
	      var publicApi = {
	        add                   : _add,
	        del                   : _del,
	        get                   : _get,
	        bindTo                : bindTo,
	        template              : this.template,
	        toggleCheatSheet      : toggleCheatSheet,
	        includeCheatSheet     : this.includeCheatSheet,
	        cheatSheetHotkey      : this.cheatSheetHotkey,
	        cheatSheetDescription : this.cheatSheetDescription,
	        useNgRoute            : this.useNgRoute,
	        purgeHotkeys          : purgeHotkeys,
	        templateTitle         : this.templateTitle,
	        pause                 : pause,
	        unpause               : unpause
	      };
	
	      return publicApi;
	
	    }];
	
	
	  }])
	
	  .directive('hotkey', ['hotkeys', function (hotkeys) {
	    return {
	      restrict: 'A',
	      link: function (scope, el, attrs) {
	        var keys = [],
	            allowIn;
	
	        angular.forEach(scope.$eval(attrs.hotkey), function (func, hotkey) {
	          // split and trim the hotkeys string into array
	          allowIn = typeof attrs.hotkeyAllowIn === "string" ? attrs.hotkeyAllowIn.split(/[\s,]+/) : [];
	
	          keys.push(hotkey);
	
	          hotkeys.add({
	            combo: hotkey,
	            description: attrs.hotkeyDescription,
	            callback: func,
	            action: attrs.hotkeyAction,
	            allowIn: allowIn
	          });
	        });
	
	        // remove the hotkey if the directive is destroyed:
	        el.bind('$destroy', function() {
	          angular.forEach(keys, hotkeys.del);
	        });
	      }
	    };
	  }])
	
	  .run(['hotkeys', function(hotkeys) {
	    // force hotkeys to run by injecting it. Without this, hotkeys only runs
	    // when a controller or something else asks for it via DI.
	  }]);
	
	})();
	
	/*global define:false */
	/**
	 * Copyright 2015 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.5.2
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	        _MAP[i + 96] = i;
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (window, document);


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/welcome');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function NavbarComponent() {
	  _classCallCheck(this, NavbarComponent);
	
	  this.menu = [{
	    title: 'Home',
	    state: 'main'
	  }];
	  this.isCollapsed = true;
	};
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(16),
	  controller: NavbarComponent
	}).name;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	module.exports = "<!-- <div class=\"navbar navbar-default navbar-static-top\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a href=\"/\" class=\"navbar-brand\">videogame</a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\">\n            <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n-->\n"

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(18),
	  controller: FooterComponent
	}).name;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>HoRIzON - driving Human Robot InteractiONs |\n    <a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/fr/isae-supaero/mecenat-relations-avec-la-fondation-isae-supaero/chaire-dassault-aviation/\">Dassault Aviation chair - ISAE-SUPAERO</a>\n  </p>\n</div>\n"

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(10);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(20);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http', '$scope', 'socket', 'hotkeys', '$timeout', '$interval', 'sharedProperties', '$rootScope', '$window'];
	  function MainController($http, $scope, socket, hotkeys, $timeout, $interval, sharedProperties, $rootScope, $window) {
	    _classCallCheck(this, MainController);
	
	    this.awesomeThings = [];
	    this.newThing = '';
	
	    $scope.language = $rootScope.language;
	
	    $scope.address = "http://robot-isae.isae.fr/test";
	
	    var tictac = 0;
	    $scope.addressUpdated = $scope.address;
	    var streamingInterval = $interval(function () {
	      tictac = tictac + 1;
	      tictac = tictac % 2;
	      $scope.addressUpdated = $scope.address + '?' + tictac;
	    }, 2000);
	    $scope.$on("$destroy", function () {
	      if (streamingInterval) {
	        $interval.cancel(streamingInterval);
	      }
	    });
	
	    $scope.cause = 0;
	    $scope.overlayOpen = false;
	
	    $scope.alarmOverlayOpen = false;
	    $scope.alarmCause = 0;
	    $scope.language = $rootScope.language || 'english';
	    if ($scope.language == 'english') {
	      $scope.alarmText = ["Low battery", "Too-high temperature", "Less than one minute before the end of the mission", "The robot's tank will soon be empty (2 shoots left)", "The robot is in autonomous mode", "The robot is in manual mode", "ground tank is leaking", "The ground tank's water level is low"];
	    } else if ($scope.language == 'french') {
	      $scope.alarmText = ["Batterie faible", "Température trop haute", "Moins d'une minute avant la fin de la mission", "Le réservoir du robot est bientôt vide (2 tirs restants)", "Le robot est en mode autonome", "Le robot est en mode manuel", "ground tank is leaking", "Le niveau d'eau du réservoir principal est faible"];
	    }
	    $scope.removeAlarm = function () {
	      $scope.alarmOverlayOpen = false;
	      $http.get('/api/control/removealarm').then(function (response) {
	        if (response.status === 200) {
	          $scope.alarmOverlayOpen = false;
	        }
	      });
	    };
	
	    $scope.finalnumfires = 0;
	    $scope.nbfighted = 0;
	    this.$http = $http;
	    this.socket = socket;
	    var debug = false;
	
	    var translationX = 19;
	    var normalizationX = 38;
	    var translationY = 19;
	    var normalizationY = 38;
	    $scope.realToCssPoseX = function (realPose) {
	      return (-5 + (realPose + translationX) * 100.0 / normalizationX).toString() + '%';
	    };
	    $scope.realToCssPoseY = function (realPose) {
	      return (95 - (realPose + translationY) * 100.0 / normalizationY).toString() + '%';
	    };
	
	    $scope.start = function () {
	      $http.get('/api/control/start').then(function (response) {
	        if (debug) {
	          console.log(response);
	        }
	        if (response.status === 200) {} else {}
	      });
	    };
	
	    var treeslocations;
	    $scope.trees = [];
	    $scope.firesloc = [];
	    $scope.opacityfire = [];
	    $http.get('/api/control').then(function (response) {
	      if (response.status === 200) {
	        treeslocations = JSON.parse(response.data);
	        $scope.trees = treeslocations;
	        for (var i = 0; i < treeslocations.length; i++) {
	          var xVal = $scope.realToCssPoseX(parseFloat(treeslocations[i].x));
	          var yVal = $scope.realToCssPoseY(parseFloat(treeslocations[i].y));
	          $scope.trees[i].x = xVal;
	          $scope.trees[i].y = yVal;
	          $scope.firesloc.push({ x: xVal, y: (parseFloat(yVal.slice(0, -1)) - 3.8).toString() + '%' });
	          $scope.opacityfire.push(0);
	        }
	      }
	    });
	
	    var zoneslocations;
	    $scope.zones = [];
	    $http.get('/api/control/zones').then(function (response) {
	      if (response.status === 200) {
	        zoneslocations = JSON.parse(response.data);
	        $scope.zones = zoneslocations;
	        for (var i = 0; i < zoneslocations.length; i++) {
	          var xValz = $scope.realToCssPoseX(parseFloat(zoneslocations[i].x));
	          var yValz = $scope.realToCssPoseY(parseFloat(zoneslocations[i].y));
	          $scope.zones[i].x = xValz;
	          $scope.zones[i].y = yValz;
	        }
	      }
	    });
	
	    $scope.firstPump = 2;
	    $scope.nbonfire = 0;
	    var coeffXrob = 10;
	    var constXrob = 50;
	    var mainInterval = $interval(function () {
	      $http.get('/api/control/fires').then(function (response) {
	        if (response.status === 200) {
	          var sum = 0;
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i]) {
	              $scope.opacityfire[i] = 1;
	              sum++;
	            } else {
	              $scope.opacityfire[i] = 0;
	            }
	          }
	          $scope.nbonfire = sum;
	        }
	      });
	      $http.get('/api/control/fightedfires').then(function (response) {
	        if (response.status === 200) {
	          $scope.nbfighted = response.data;
	        }
	      });
	      $http.get('/api/control/robotwater').then(function (response) {
	        if (response.status === 200) {
	          $scope.watlevel = response.data[0];
	          robotTankEmpty = response.data[1];
	        }
	      });
	      $http.get('/api/control/battery').then(function (response) {
	        if (response.status === 200) {
	          $scope.battlevel = response.data;
	        }
	      });
	      $http.get('/api/control/time').then(function (response) {
	        if (response.status === 200) {
	          $scope.remainingtime = response.data;
	        }
	      });
	      $http.get('/api/control/watermanagement').then(function (response) {
	        if (response.status === 200) {
	          $scope.xrobinet = response.data[0];
	          var waterwidth = response.data[1];
	          $scope.watlevelContainer = response.data[2];
	          $scope.watlevelContainerMap = (94 - $scope.watlevelContainer) / 5;
	          $scope.xrobinetwater = $scope.xrobinet + decal;
	          var fxa = ($scope.xrobinet - 40) * 10 / 40;
	          $scope.faucetxaxis = fxa.toPrecision(3);
	          $scope.yrobinet = coeffXrob * Math.cos($scope.faucetxaxis * 3.1415 * 2 / 20) + constXrob;
	          $scope.waterwidth = waterwidth / 10;
	        }
	      });
	      $http.get('/api/control/temperature').then(function (response) {
	        if (response.status === 200) {
	          $scope.mercurelevel = response.data[0];
	          $scope.hotscreen = response.data[1];
	        }
	      });
	
	      $http.get('/api/control/robot').then(function (response) {
	        if (response.status === 200) {
	          $scope.propFromLeft = $scope.realToCssPoseX(response.data[0]);
	          $scope.propFromTop = $scope.realToCssPoseY(response.data[1]);
	          $scope.rotindeg = 180 - (response.data[2] + 3.14) * 360 / (2 * 3.14);
	          $scope.waterize = response.data[3];
	          $scope.autonomous = response.data[4];
	        }
	      });
	
	      $http.get('/api/control/finished').then(function (response) {
	        if (response.status === 200) {
	          $scope.overlayOpen = response.data[0];
	          $scope.cause = response.data[1];
	          $scope.finalnumfires = response.data[2];
	          $scope.newBestScore = response.data[3];
	          $scope.winnerPseudo = response.data[4];
	        }
	      });
	
	      $http.get('/api/control/alarms').then(function (response) {
	        if (response.status === 200) {
	          $scope.alarmOverlayOpen = response.data[0];
	          $scope.alarmCause = response.data[1];
	        }
	      });
	    }, 500);
	    $scope.$on("$destroy", function () {
	      if (mainInterval) {
	        $interval.cancel(mainInterval);
	      }
	    });
	
	    $scope.leaksReverse = [];
	    $scope.leftValues = [0, 0, 0, 0, 0, 0, 0, 0, 0];
	    var previousNoleakat = [true, true, true, true, true, true, true, true, true];
	
	    var leaksInterval = $interval(function () {
	      $http.get('/api/control/leaks').then(function (response) {
	        if (response.status === 200) {
	          $scope.leakPlaces = response.data[0];
	          $scope.noleakat = response.data[1];
	          for (var i = 0; i < $scope.leakPlaces.length; i++) {
	            if (!$scope.noleakat[i] && previousNoleakat[i]) {
	              if (Math.random() > 0.5) {
	                $scope.leaksReverse[i] = -1;
	              } else {
	                $scope.leaksReverse[i] = 1;
	              }
	              $scope.leftValues[i] = Math.random() * 30;
	            }
	          }
	          previousNoleakat = $scope.noleakat;
	        }
	      });
	    }, 500);
	    $scope.$on("$destroy", function () {
	      if (leaksInterval) {
	        $interval.cancel(leaksInterval);
	      }
	    });
	
	    $scope.iconBatt = 0;
	
	    $scope.gohome = function () {
	      $timeout(function () {
	        $window.location.reload();
	      }, 100);
	    };
	
	    var pending = false;
	    var myToken = $rootScope.token;
	    $scope.killall = function () {
	      myToken = $rootScope.token;
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control/killall', { token: myToken }).then(function (response) {
	          pending = false;
	          if (debug) {
	            console.log($rootScope.token);
	          }
	          if (response.status === 200) {
	            $http.post('/api/auth/newtoken', { token: myToken }).then(function (response) {
	              if (response.status === 200) {
	                $window.location.reload();
	              } else if (debug) {
	                console.log('nok auth');
	              }
	            });
	          } else if (debug) {
	            console.log('nok control');
	          }
	        });
	      }
	    };
	
	    var pressedKeys = [];
	    window.onkeyup = function (e) {
	      pressedKeys[e.keyCode] = false;
	      if (e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40 && e.keyCode != 32 && e.keyCode != 68 && e.keyCode != 69 && e.keyCode != 83 && e.keyCode != 65) {
	        myToken = $rootScope.token;
	        if (debug) {
	          console.log('anyotherkey');
	          console.log("pending:");
	          console.log(pending);
	        }
	        if (!pending) {
	          pending = true;
	          $http.post('/api/control/otherkey', { key: 'otherkeyUp', token: myToken }).then(function (response) {
	            pending = false;
	            if (response.status === 200) {
	              console.log('other sent');
	            } else if (debug) {
	              console.log('nok');
	            }
	          });
	        }
	      }
	    };
	    window.onkeydown = function (e) {
	      pressedKeys[e.keyCode] = true;
	      if (e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40 && e.keyCode != 32 && e.keyCode != 68 && e.keyCode != 69 && e.keyCode != 83 && e.keyCode != 65) {
	        myToken = $rootScope.token;
	        if (debug) {
	          console.log('anyotherkey');
	          console.log("pending:");
	          console.log(pending);
	        }
	        if (!pending) {
	          pending = true;
	          $http.post('/api/control/otherkey', { key: 'otherkeyDown', token: myToken }).then(function (response) {
	            pending = false;
	            if (response.status === 200) {
	              console.log('other sent');
	            } else if (debug) {
	              console.log('nok');
	            }
	          });
	        }
	      }
	    };
	
	
	    $scope.otherclick = function () {
	      console.log("click!");
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('otherclick');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control/otherkey', { key: 'otherClick', token: myToken }).then(function (response) {
	          pending = false;
	          if (response.status === 200) {
	            console.log('other sent');
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    var keysInterval = $interval(function () {
	      if (pressedKeys[38] && !pressedKeys[37] && !pressedKeys[39]) {
	        $scope.forward();
	      }
	      if (pressedKeys[40] && !pressedKeys[37] && !pressedKeys[39]) {
	        $scope.backward();
	      }
	      if (pressedKeys[37] && !pressedKeys[38] && !pressedKeys[40]) {
	        $scope.totheleft();
	      }
	      if (pressedKeys[39] && !pressedKeys[38] && !pressedKeys[40]) {
	        $scope.totheright();
	      }
	    }, 300);
	
	    $scope.$on("$destroy", function () {
	      if (keysInterval) {
	        $interval.cancel(keysInterval);
	      }
	    });
	
	    $scope.totheleft = function () {
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('totheleft');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control', { key: 'left', token: myToken }).then(function (response) {
	          pending = false;
	          if (response.status === 200) {
	            $scope.propFromTop = $scope.realToCssPoseY(response.data.posY[0]);
	            $scope.propFromLeft = $scope.realToCssPoseX(response.data.posX[0]);
	            $scope.rotindeg = 180 - (response.data.orientation[0] + 3.14) * 360 / (2 * 3.14);
	            if (debug) {
	              console.log(response.data.posX[0]);
	              console.log(response.data.posY[0]);
	              console.log(response.data.orientation[0]);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    $scope.totheright = function () {
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('totheright');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control', { key: 'right', token: myToken }).then(function (response) {
	          pending = false;
	          if (response.status === 200) {
	            $scope.propFromTop = $scope.realToCssPoseY(response.data.posY[0]);
	            $scope.propFromLeft = $scope.realToCssPoseX(response.data.posX[0]);
	            $scope.rotindeg = 180 - (response.data.orientation[0] + 3.14) * 360 / (2 * 3.14);
	            if (debug) {
	              console.log(response.data.posX[0]);
	              console.log(response.data.posY[0]);
	              console.log(response.data.orientation[0]);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    $scope.backward = function () {
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('backward');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control', { key: 'back', token: myToken }).then(function (response) {
	          pending = false;
	          if (response.status === 200) {
	            $scope.propFromTop = $scope.realToCssPoseY(response.data.posY[0]);
	            $scope.propFromLeft = $scope.realToCssPoseX(response.data.posX[0]);
	            $scope.rotindeg = 180 - (response.data.orientation[0] + 3.14) * 360 / (2 * 3.14);
	            if (debug) {
	              console.log(response.data.posX[0]);
	              console.log(response.data.posY[0]);
	              console.log(response.data.orientation[0]);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    $scope.forward = function () {
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('forward');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!pending) {
	        pending = true;
	        $http.post('/api/control', { key: 'front', token: myToken }).then(function (response) {
	          pending = false;
	          if (response.status === 200) {
	            $scope.propFromTop = $scope.realToCssPoseY(response.data.posY[0]);
	            $scope.propFromLeft = $scope.realToCssPoseX(response.data.posX[0]);
	            $scope.rotindeg = 180 - (response.data.orientation[0] + 3.14) * 360 / (2 * 3.14);
	            if (debug) {
	              console.log(response.data.posX[0]);
	              console.log(response.data.posY[0]);
	              console.log(response.data.orientation[0]);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    var robotTankEmpty;
	    $scope.water = function () {
	      myToken = $rootScope.token;
	      if (debug) {
	        console.log('WATER');
	        console.log("pending:");
	        console.log(pending);
	      }
	      if (!robotTankEmpty) {
	        if (!pending) {
	          pending = true;
	          $http.post('/api/control', { key: 'space', token: myToken }).then(function (response) {
	            pending = false;
	            if (response.status === 200) {
	              $scope.propFromTop = $scope.realToCssPoseY(response.data.posY[0]);
	              $scope.propFromLeft = $scope.realToCssPoseX(response.data.posX[0]);
	              $scope.watlevel = response.data.waterlevel;
	              $scope.waterize = response.data.splatch;
	              console.log(response.data.waterlevel);
	              if (debug) {}
	            } else if (debug) {
	              console.log('nok');
	            }
	          });
	        }
	      }
	    };
	
	    $scope.xrobinet = 42;
	    var decal = 4;
	    var vlvop = 1;
	    $scope.watlevelContainer = 50;
	
	    var pendingButtons = false;
	    $scope.faucetcontrol = 0;
	
	    $scope.faucetctrlfctplus = function () {
	      myToken = $rootScope.token;
	      if ($scope.faucetcontrol < 3) {
	        if (!pendingButtons) {
	          pendingButtons = true;
	          $http.post('/api/control/watercontrol', { button: 'plusT', token: myToken }).then(function (response) {
	            pendingButtons = false;
	            if (response.status === 200) {
	              $scope.faucetcontrol = response.data.tapControl;
	              if (response.data.tapControl > 0) {
	                $scope.direction = 1;
	              } else if (response.data.tapControl < 0) {
	                $scope.direction = -1;
	              } else {
	                $scope.direction = 0;
	              }
	              $scope.animtime = 7 - Math.abs($scope.faucetcontrol) * 2;
	              if ($scope.faucetcontrol > 0) {
	                $scope.faucetcontrol = '+' + $scope.faucetcontrol;
	              }
	            } else if (debug) {
	              console.log('nok');
	            }
	          });
	        }
	      }
	    };
	
	    $scope.faucetctrlfctminus = function () {
	      myToken = $rootScope.token;
	      if ($scope.faucetcontrol > -3) {
	        if (!pendingButtons) {
	          pendingButtons = true;
	          $http.post('/api/control/watercontrol', { button: 'minusT', token: myToken }).then(function (response) {
	            pendingButtons = false;
	            if (response.status === 200) {
	              $scope.faucetcontrol = response.data.tapControl;
	              if (response.data.tapControl > 0) {
	                $scope.direction = 1;
	              } else if (response.data.tapControl < 0) {
	                $scope.direction = -1;
	              } else {
	                $scope.direction = 0;
	              }
	
	              $scope.animtime = 10 - Math.abs($scope.faucetcontrol) * 3;
	              if ($scope.faucetcontrol > 0) {
	                $scope.faucetcontrol = '+' + $scope.faucetcontrol;
	              }
	            } else if (debug) {
	              console.log('nok');
	            }
	          });
	        }
	      }
	    };
	
	    $scope.waterwidth = 0;
	    $scope.waterPushButton = function () {
	      myToken = $rootScope.token;
	      if (!pendingButtons) {
	        pendingButtons = true;
	        $http.post('/api/control/watercontrol', { button: 'pushButton', token: myToken }).then(function (response) {
	          pendingButtons = false;
	          if (response.status === 200) {
	            if (debug) {
	              console.log("pushbutton well received");
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    $scope.wrenchOnOff = function () {
	      myToken = $rootScope.token;
	      if (!pendingButtons) {
	        pendingButtons = true;
	        $http.post('/api/control/watercontrol', { button: 'wrenchButton', token: myToken }).then(function (response) {
	          pendingButtons = false;
	          if (response.status === 200) {
	            $scope.wrenchMode = response.data.wrenchMode;
	            if (debug) {
	              console.log("wrench mode ON/OFF! MODE: " + $scope.wrenchMode);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	    $scope.faucetctrlfctplusKey = function () {
	      myToken = $rootScope.token;
	      if ($scope.faucetcontrol < 3) {
	        if (!pendingButtons) {
	          pendingButtons = true;
	          $http.post('/api/control/watercontrol', { button: 'plusT', token: myToken }).then(function (response) {
	            pendingButtons = false;
	            if (response.status === 200) {
	              $scope.faucetcontrol = response.data.tapControl;
	              if (response.data.tapControl > 0) {
	                $scope.direction = 1;
	              } else if (response.data.tapControl < 0) {
	                $scope.direction = -1;
	              } else {
	                $scope.direction = 0;
	              }
	              $scope.animtime = 7 - Math.abs($scope.faucetcontrol) * 2;
	              if ($scope.faucetcontrol > 0) {
	                $scope.faucetcontrol = '+' + $scope.faucetcontrol;
	              }
	            } else if (debug) {
	              console.log('nok');
	            }
	
	            $http.post('/api/control/keyboard', { token: myToken }).then(function (response) {
	              pendingButtons = false;
	              if (response.status === 200) {
	                console.log("keyboard");
	              }
	            });
	          });
	        }
	      }
	    };
	
	    $scope.faucetctrlfctminusKey = function () {
	      myToken = $rootScope.token;
	      if ($scope.faucetcontrol > -3) {
	        if (!pendingButtons) {
	          pendingButtons = true;
	          $http.post('/api/control/watercontrol', { button: 'minusT', token: myToken }).then(function (response) {
	            if (response.status === 200) {
	              $scope.faucetcontrol = response.data.tapControl;
	              if (response.data.tapControl > 0) {
	                $scope.direction = 1;
	              } else if (response.data.tapControl < 0) {
	                $scope.direction = -1;
	              } else {
	                $scope.direction = 0;
	              }
	
	              $scope.animtime = 10 - Math.abs($scope.faucetcontrol) * 3;
	              if ($scope.faucetcontrol > 0) {
	                $scope.faucetcontrol = '+' + $scope.faucetcontrol;
	              }
	            } else if (debug) {
	              console.log('nok');
	            }
	
	            $http.post('/api/control/keyboard', { token: myToken }).then(function (response) {
	              pendingButtons = false;
	              if (response.status === 200) {
	                console.log("keyboard");
	              }
	            });
	          });
	        }
	      }
	    };
	
	    $scope.waterPushButtonKey = function () {
	      myToken = $rootScope.token;
	      if (!pendingButtons) {
	        pendingButtons = true;
	        $http.post('/api/control/watercontrol', { button: 'pushButton', token: myToken }).then(function (response) {
	          if (response.status === 200) {
	            if (debug) {
	              console.log("pushbutton well received");
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	
	          $http.post('/api/control/keyboard', { token: myToken }).then(function (response) {
	            pendingButtons = false;
	            if (response.status === 200) {
	              console.log("keyboard");
	            }
	          });
	        });
	      }
	    };
	
	    $scope.wrenchOnOffKey = function () {
	      myToken = $rootScope.token;
	      if (!pendingButtons) {
	        pendingButtons = true;
	        $http.post('/api/control/watercontrol', { button: 'wrenchButton', token: myToken }).then(function (response) {
	          if (response.status === 200) {
	            $scope.wrenchMode = response.data.wrenchMode;
	            if (debug) {
	              console.log("wrench mode ON/OFF! MODE: " + $scope.wrenchMode);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	
	          $http.post('/api/control/keyboard', { token: myToken }).then(function (response) {
	            pendingButtons = false;
	            if (response.status === 200) {
	              console.log("keyboard");
	            }
	          });
	        });
	      }
	    };
	
	    $scope.clickLeak = function (leakId) {
	      myToken = $rootScope.token;
	      if (!pendingButtons) {
	        pendingButtons = true;
	        $http.post('/api/control/watercontrol', { button: 'clickLeak', leakid: leakId, token: myToken }).then(function (response) {
	          pendingButtons = false;
	          if (response.status === 200) {
	            $scope.noleakat = response.data.noLeakAt;
	            $scope.wrenchMode = response.data.wrenchMode;
	            if (debug) {
	              console.log("clikleak -- : " + $scope.noleakat);
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      }
	    };
	
	
	    $scope.otherKey = function () {
	      console.log('other');
	    };
	
	    hotkeys.add('left', 'totheleft', $scope.totheleft);
	    hotkeys.add('right', 'totheright', $scope.totheright);
	    hotkeys.add('down', 'backward', $scope.backward);
	    hotkeys.add('up', 'forward', $scope.forward);
	    hotkeys.add('space', 'water', $scope.water);
	
	    hotkeys.add('s', 'tapleft', $scope.faucetctrlfctminusKey);
	    hotkeys.add('d', 'tapright', $scope.faucetctrlfctplusKey);
	    hotkeys.add('e', 'pushbutton', $scope.waterPushButtonKey);
	    hotkeys.add('a', 'wrench', $scope.wrenchOnOffKey);
	  }
	
	  _createClass(MainController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get('/api/things').then(function (response) {
	        _this.awesomeThings = response.data;
	        _this.socket.syncUpdates('thing', _this.awesomeThings);
	      });
	    }
	  }, {
	    key: 'addThing',
	    value: function addThing() {
	      if (this.newThing) {
	        this.$http.post('/api/things', {
	          name: this.newThing
	        });
	        this.newThing = '';
	      }
	    }
	  }, {
	    key: 'deleteThing',
	    value: function deleteThing(thing) {
	      this.$http.delete('/api/things/' + thing._id);
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('videogameApp.main', [_angularUiRouter2.default]).config(_main2.default).component('game', {
	  template: __webpack_require__(21),
	  controller: MainController
	}).name;

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('game', {
	    url: '/game',
	    template: '<game></game>'
	  });
	}

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	module.exports = "<!-- <header class=\"hero-unit\" id=\"banner\">\n  <div class=\"container\">\n    <h1>'Allo, 'Allo!</h1>\n    <p class=\"lead\">Kick-start your next web app with Angular Fullstack</p>\n    <img src=\"assets/images/yeoman.png\" alt=\"I'm Yeoman\">\n  </div>\n</header>\n\n<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h1 class=\"page-header\">Features:</h1>\n      <ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">\n        <li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>\n      </ul>\n    </div>\n  </div>\n\n  <form class=\"thing-form\">\n    <label>Syncs in realtime across clients</label>\n    <p class=\"input-group\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">\n      <span class=\"input-group-btn\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>\n      </span>\n    </p>\n  </form>\n</div> -->\n\n    <!-- OVERLAYS -->\n\n\n                <!-- <div class=\"loadGif\">\n\t\t</div> \n\t\t<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular> -->\n\n<div class=\"screen\" ng-class=\"{screenWrench: wrenchMode}\" ng-click=\"otherclick()\">\n\t<div ng-class=\"{overlayOpen: overlayOpen}\" class=\"overlay\">\n\t\t<div class=\"gameover\" ng-if=\"cause==1 || cause==2\"> GAME OVER! </div>\n                <div class=\"gameover\" ng-if=\"cause==0\"> THE END </div>\n                <div class=\"textthx\" ng-if=\"cause==0\"> Mission completed, CONGRATULATION! </div>\n\t\t<div class=\"whyover\" ng-if=\"cause==1\"> \n\t\t\t<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> \n\t\t\t<div class=\"textcause\"> Battery empty </div> \n\t\t\t<i class=\"fa fa-battery-empty\" aria-hidden=\"true\"></i> \n\t\t</div>\n\t\t<div class=\"whyover\" ng-if=\"cause==2\"> \n\t\t\t<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> \n\t\t\t<div class=\"textcause\"> Overheat </div> \n\t\t\t<i class=\"fa fa-thermometer-full\" aria-hidden=\"true\"></i> \n\t\t</div>\n\t\t<div class=\"numextfires\"> \n\t\t\t<div class=\"fireicon\"> </div> \n\t\t\t<span> {{finalnumfires}} extinguished fires </span> \n\t\t\t<i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i> \n\t\t</div>\n\t\t<div class=\"newbestscore\" ng-if=\"newBestScore\"> \n\t\t\t<span> NEW BEST SCORE! Good job </span> <span style=\"color: #05BDFF\">&nbsp;{{winnerPseudo}}</span> <span>!</span>\n\t\t\t<!-- pseudo: <input type=\"text\" maxlength=\"10\" ng-model=\"user.pseudo\" /> <div class=\"validpseudo\" ui-sref=\"welcome\" ng-click=\"sendpseudo()\"> OK </div> -->\n\t\t</div>\n\t\t<div ng-click=\"gohome()\" ui-sref=\"welcome\" class=\"gohome\"> \n\t\t\t<i class=\"fa fa-reply\" aria-hidden=\"true\"></i> \n\t\t\t<span> back to main menu </span> \n\t\t</div>\n\t</div> \n\n\n\t<div ng-class=\"{overlayOpen: alarmOverlayOpen}\" class=\"alarmOverlay\">\n\t\t<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> \n\t\t<span class=\"textAlarm\"> {{alarmText[alarmCause]}} ! </span>\n\t\t<div class=\"alarmButton\" ng-click=\"removeAlarm()\"> I got it </div>\t\n\t</div>\n\n\t<div class=\"leftPart\">  \n\t\t<div class=\"missionBlock\">\n\t\t\t<div class=\"maincontainermission\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-trophy\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gametitle\">\n\t\t\t\t\tFirefighter Human-Robot Team <div class=\"fireicon\"> </div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"infonoff\">\t\n\t\t\t\t\t<div class=\"missioninfo\">\n\t\t\t\t\t\t<div class=\"numbersinfo\"> \n\t\t\t\t\t\t\t<!-- <i class=\"fa fa-star-o\" aria-hidden=\"true\"></i> -->\n\t\t\t\t\t\t\t<i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t{{nbfighted}} \n\t\t\t\t\t\t</div> \n\t\t\t\t\t\t<div  class=\"numbersinfo\"> <i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i>   {{remainingtime}} </div>\n\t\t\t\t\t\t\t<!--<button ng-click=\"killall()\" ui-sref=\"welcome\">Kill all!</button>-->\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"onoff\">\t\t\t\t\t\t\n\t\t\t\t\t\t<i ng-click=\"killall()\" ui-sref=\"welcome\" class=\"fa fa-power-off\" aria-hidden=\"true\"></i>\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"waterBlock\"> \n\t\t\t<div class=\"maincontainer\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t                        <div class=\"robinetcontainer\">\n\t\t\t\t\t<div class=\"robinet\" ng-style=\"{left: xrobinet+2+'%', bottom: yrobinet/1.8 + 42 +'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction!=0\" ng-class=\"{wheelinverse: direction<0}\"  ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+58+'%', 'animation-duration': animtime + 's'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction==0\" ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+58+'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"string\" ng-style=\"{left: xrobinet+11.5+'%', bottom: yrobinet/1.8+52+'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"robinetwaterContainer\" ng-style=\"{left: xrobinetwater-0.6+'%', bottom: yrobinet/1.8 + 37 +'%'}\">\n\t\t\t\t\t\t<div class=\"robinetwater\" ng-style=\"{width: waterwidth + 'vw', 'background-size': waterwidth + 'vw 1vw'}\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"montainAxis\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"neckcontainer\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"tankcontainer\">\t\n\t\t\t\t\t\t<div class=\"tankcontainerwaterpart\">\n\t\t\t\t\t\t\t<div class=\"tankcontainerwaterviz\">\n\t\t\t\t\t\t\t\t<div class=\"graduations\"> </div>\n\t\t\t\t\t\t\t\t<div class=\"tankcontainerwater\" ng-style=\"{height: watlevelContainer + '%'}\"> \n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n<!-- TODO manage water level w.r.t leaks and pushbutton and tap position\nleaks/wrench/etc in server files-->\n\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t<div class=\"tankcontainerleakspart\">\n\t\t\t\t\t\t\t<!--<div class=\"bigCross\" ng-class=\"{nonvisible: !brokenContainer}\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\" ng-style=\"{'font-size': crossSize + 'vw'}\"></i>\n\t\t\t\t\t\t\t</div>-->\n<!--  -->\n\t\t\t\t\t\t\t<div class=\"wrapLeaks\">\n\t\t\t\t\t\t\t\t<div class=\"leakContainer\" ng-repeat=\"(key, value) in leakPlaces\">\n\t\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[key]}\" ng-style=\"{'transform': 'scale(' + leaksReverse[key] + ', 1)', 'left': leftValues[key] + '%'}\"  ng-click=\"clickLeak(key); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n<!--\t\t\t\t\t\t\t<div class=\"topleaks\">\n\t\t\t\t\t\t\t\t<div class=\"leaks\">\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[0]}\" ng-click=\"clickLeak(0)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[1]}\" ng-click=\"clickLeak(1)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t<div class=\"containertap\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leaks\">\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[2]}\" ng-click=\"clickLeak(2)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[3]}\" ng-click=\"clickLeak(3)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"botleaks\">\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[4]}\" ng-click=\"clickLeak(4)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[5]}\" ng-click=\"clickLeak(5)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[6]}\" ng-click=\"clickLeak(6)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[7]}\" ng-click=\"clickLeak(7)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n-->\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"legsContainer\">\n\t\t\t\t\t\t\t<div class=\"legs\">\n\t\t\t\t\t\t\t</div>                           \t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n<!--\n\t\t\t\t\t<div> \n\t\t\t\t\t\t<span> TAP POSITION: {{faucetxaxis}} </span> \n\t\t\t\t\t\t \n\t\t\t\t\t</div>\n-->\n\t\t\t\t\t<div class=\"wmbuttons\">\n\t\t\t\t\t\t<!-- <i class=\"fa fa-mouse-pointer\" aria-hidden=\"true\"></i> -->\n\t\t\t\t\t\t<div class=\"speed\">  \n\t\t\t\t\t\t\t<div class=\"wheelsmall2\"> </div>\n\t\t\t\t\t\t\t<div ng-if=\"language=='english'\"> speed: {{faucetcontrol}} </div>\n\t\t\t\t\t\t\t<div ng-if=\"language=='french'\"> vitesse: {{faucetcontrol}} </div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonWheel\">\n\t\t\t\t\t\t\t<div class=\"buttonChar\">\n\t\t\t\t\t\t\t\t<div class=\"mainbuttonL\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"faucetctrlfctminus(); $event.stopPropagation();\"> \n\t\t\t\t\t\t\t\t\t<div class=\"undo\"> <i class=\"fa fa-undo\" aria-hidden=\"true\"></i></div>\n\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"char\"> s </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t\t<div class=\"mainbuttonR\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"faucetctrlfctplus(); $event.stopPropagation();\"> \n\t\t\t\t\t\t\t\t\t<div class=\"undo\">  <i class=\"fa fa-undo\" aria-hidden=\"true\"></i> </div>\n\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"char\"> d </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t<div class=\"pushButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"waterPushButton(); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t<!--<div class=\"pbcircle\">\n\t\t\t\t\t\t\t\t\t<div class=\"pbcirclesmall\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>-->\n\t\t\t\t\t\t\t\t<div class=\"buttonTap\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"char\"> e </div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t<div class=\"wrenchButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"wrenchOnOff(); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"char\"> a </div>\n\t\t\t\t\t\t</div>\n<!--\n\t\t\t\t\t\t<div class=\"newContainerButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"newContainer()\">\n\t\t\t\t\t\t\t<div class=\"containerIcon\">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>-->\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\t\t\t\t\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"rightPart\"> \n\t\t<div class=\"videoBlock\"> \n\t\t\t<div class=\"maincontainercam\">\n<!--\t\t\t\t<div class=\"iconCircle\"> \n\t\t\t\t\t<i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t\n-->\n\t\t\t\t<div class=\"streamcamera\">\n\n\t\t\t\t\t<img class=\"imagecam\" ng-src={{addressUpdated}} scrolling=\"no\" frameBorder=\"0\">\n<!--\t\t\t\t\t<img class=\"imagecam\" ng-src=\"http://localhost:8081/?action=stream\"   scrolling=\"no\" frameBorder=\"0\">\n\t\t\t\t\t<img class=\"imagecam\" src=\"http://{{ipaddress}}:8080/?action=stream\" scrolling=\"no\" frameBorder=\"0\"> -->\n\t\t\t\t\t<div class=\"splatchContainer\">\n\t\t\t\t        \t<div class=\"splatch\" ng-class=\"{visiblesplatch: waterize}\">\n\t\t\t\t        \t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"redhotContainer\">\n\t\t\t\t        \t<div class=\"redhot\" ng-style=\"{opacity: hotscreen}\">\n\t\t\t\t        \t</div>\n\t\t\t\t\t</div>\n<!--\t\t\t\t\t<div class=\"automanual\">\n\t\t\t\t\t\t<span ng-if=\"autonomous\"> AUTONOMOUS </span>\n\t\t\t\t\t\t<span ng-if=\"!autonomous\"> MANUAL </span>\n\t\t\t\t\t</div> -->\n\t\t\t\t</div>\n\t\t\t</div>\t\t\n\t\t</div>\n\t\t<div class=\"infoBlock\"> \n\t\t\t<div class=\"maincontainer\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"iconscontents\">\n\t\t\t\t\t<div class=\"linktoicon\">\n\t\t\t\t\t\t<i class=\"fa fa-globe\" aria-hidden=\"true\"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"maincontainersec\">\n\t\t\t\t\t\t<div class=\"mapblock\">\n\t\t\t\t\t\t\t<div class=\"map\">\n\t\t\t\t\t\t\t\t<div class=\"point\" ng-style=\"{top: propFromTop, left: propFromLeft, transform: 'rotate('+ rotindeg +'deg)'}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"tree\" ng-repeat=\"(key, value) in trees\" ng-style=\"{top: value.y, left: value.x}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"fire\" ng-repeat=\"(key, value) in firesloc\" ng-style=\"{top: value.y, left: value.x, opacity: opacityfire[key]}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"loadlocB\" ng-style=\"{top: zones[1].y, left: zones[1].x}\">\n\t\t\t\t\t\t\t\t<!--<i class=\"fa fa-battery-empty\" ng-show=\"iconBatt==0\"></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-battery-quarter\" ng-show=\"iconBatt==1\"></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-battery-half\" ng-show=\"iconBatt==2\"></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-battery-three-quarters\" ng-show=\"iconBatt==3\"></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-battery-full\" ng-show=\"iconBatt==4\"></i>-->\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-bolt\" aria-hidden=\"true\"></i>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"loadlocW\" ng-style=\"{top: zones[0].y, left: zones[0].x}\">\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"waterlevelmap\" ng-style=\"{height: watlevelContainerMap + 'px'}\">\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!--<span> {{nbonfire}} </span>-->\n\t\t\t\t</div>\n\t\t\t\t<div class=\"iconscontents2\">\n\t\t\t\t\t<div class=\"linktoicon\">\n\t\t\t\t\t\t<div class=\"robothead\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"maincontainersec2\">\n\t\t\t\t\t\t<div class=\"warningsblock\">\n\t\t\t\t\t\t\t<div class=\"robtoppart\">\n\t\t\t\t\t\t\t\t<div class=\"autonomy\">\n\t\t\t\t\t\t\t\t\t<div class=\"brain\" ng-if=\"autonomous\"> <!-- <i class=\"fa fa-signal\" aria-hidden=\"true\"></i> --> </div>\n\t\t\t\t\t\t\t\t\t<div class=\"keyboard\" ng-if=\"!autonomous\"> </div>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"autonomous && language=='english'\"> AUTONOMOUS </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!autonomous && language=='english'\"> MANUAL </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"autonomous && language=='french'\"> AUTONOME </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!autonomous && language=='french'\"> MANUEL </span>  \t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"batTemp\">\n\t\t\t\t\t\t\t\t\t<div class=\"connectbat\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"battery\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"batlev\"  ng-style=\"{width: battlevel+'%'}\">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"batconnect\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"therm\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"temperature\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"cercle\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"bluecercle\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"someRed\">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"thermometer\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"mercure\" ng-style=\"{height: mercurelevel}\"> \t\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"robotwaterres\">\n\t\t\t\t\t\t\t\t<div class=\"littlesplatchwhite\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"waterlevelbar\">\n\t\t\t\t\t\t\t\t\t<div class=\"waterlevelcont\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"waterlevel\" ng-style=\"{width: watlevel +'%'}\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n<!--\n\t<div class=\"camerablock\">\n\t\t<div class=\"scores\">\n\t\t\t<div class=\"nbfighted\">\n\t\t\t\t<div> {{nbfighted}} </div>\n\t\t\t\t<div class=\"unit\"> offs </div>\n\t\t\t</div>\n\t\t\t<div class=\"nbonfire\">\n\t\t\t\t<div> {{nbonfire}} </div>\n\t\t\t\t<div class=\"unit\"> fires </div>\n\t\t\t</div>\n\t\t\t<div class=\"remainingtime\">\n\t\t\t\t<div> {{remainingtime}} </div>\n\t\t\t\t<div class=\"unit\"> secs </div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cameracontainer\">\n\t\t\t<iframe class=\"streamcamera\" src=\"http://localhost:8080/?action=stream\"   scrolling=\"no\" frameBorder=\"0\">\t\t \t\n\t\t\t</iframe>\n\t\t\t<div class=\"splatchContainer\">\n                        \t<div class=\"splatch\" ng-class=\"{visiblesplatch: waterize}\" >\n                        \t</div>\n\t\t\t</div>\n\t\t\t<div class=\"redhotContainer\">\n                        \t<div class=\"redhot\" ng-style=\"{opacity: hotscreen}\">\n                        \t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"temperature\"> \n\t\t\t<div class=\"thermometer\"> \t\n\t\t\t</div>\n\t\t\t<div class=\"cercle\">\n\t\t\t</div>\n\t\t\t<div class=\"mercure\" ng-style=\"{height: mercurelevel}\"> \t\n\t\t\t</div>\n\t\t\t<div class=\"bluecercle\">\n\t\t\t</div>\n\t\t</div>\t\n\t</div>\n\t<div class=\"dashboardblock\">\n\t\t<div class=\"dashboard\">\n\t\t\t<div class=\"matbblock\">\n                                <div class=\"title\"> WATER MANAGEMENT: \n\t\t\t\t</div>\n\t\t\t\t<div class=\"wMngmtViz\">\n\t\t\t\t\t<div class=\"crosscontainer\">\n\t\t\t\t\t\t<div class=\"filter\">\n\t\t\t\t\t\t\t<div class=\"bottompumps\">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"apump\" ng-repeat=\"(key,value) in pumps\" ng-style=\"{bottom: value + '%'}\">\n\t\t\t\t\t\t\t\t<div class=\"pumpinput\" ng-click=\"clickPump(key+1)\" ng-class=\"{pumpborder: pumpSelected==key+1}\">\n\t\t\t\t\t\t\t\t\t{{pumpsFlows[key]}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"plusminusbuttons\">\n\t\t\t\t\t\t\t\t\t<div class=\"plusbutton fa fa-plus-square\" ng-click=\"pumpPlus(key)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"minusbutton fa fa-minus-square\" ng-click=\"pumpMinus(key)\">\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"trashpipe\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"inpipe\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"outpipe\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"backpipe\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"initpipe\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"trashtap\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"trashtapwater\" ng-style=\"{width: widthTrashTapWater + 'px'}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"bendedpipe\" ng-repeat=\"(key, value) in bendedpipes\" ng-style=\"{bottom: value + '%'}\" ng-class=\"{nonvisible: inoutpipes[key]}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"normalpipe\" ng-repeat=\"(key, value) in bendedpipes\" ng-style=\"{bottom: value + '%'}\" ng-class=\"{nonvisible: !inoutpipes[key]}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"initpipes\" ng-repeat=\"(key, value) in bendedpipes\" ng-style=\"{bottom: value + '%'}\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t                                <div class=\"robinetcontainer\">\n\t\t\t\t\t\t<div class=\"robinet\" ng-style=\"{left: xrobinet+'%', bottom: yrobinet - 15 +'%'}\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"wheel\" ng-style=\"{left: xrobinet+7.5+'%', bottom: yrobinet+12.5+'%'}\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"right\" ng-style=\"{left: xrobinet+9.6+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol < 3)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"right\" ng-style=\"{left: xrobinet+11.6+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol < 1)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"right\" ng-style=\"{left: xrobinet+13.6+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol < 2)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"left\" ng-style=\"{left: xrobinet+9.5+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol > -3)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"left\" ng-style=\"{left: xrobinet+7.5+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol > -1)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"left\" ng-style=\"{left: xrobinet+5.5+'%', bottom: yrobinet+15+'%'}\" ng-class=\"{nonvisible: (faucetcontrol > -2)}\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"string\" ng-style=\"{left: xrobinet+12.5+'%', bottom: yrobinet+3+'%'}\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"robinetwater\" ng-style=\"{left: xrobinetwater-2+'%', bottom: yrobinet - 20 +'%'}\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"montainAxis\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"neckcontainer\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"tankcontainer\">\n\t\t\t\t\t\t\t<div class=\"tankcontainerwater\" ng-style=\"{height: watlevelContainer-4+'%'}\"> \n\t\t\t\t\t\t\t</div>                                \t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"faucetaxis\"> \n\t\t\t\t\t\t\t<span> TAP POSITION: </span> \n\t\t\t\t\t\t\t<span> {{faucetxaxis}} </span> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"force\"> \n\t\t\t\t\t\t\t<span> FORCE: {{faucetcontrol}} </span> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mainbuttonL\" ng-click=\"faucetctrlfctminus()\"> <i class=\"fa fa-chevron-circle-left\" aria-hidden=\"true\"></i>\n \t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mainbuttonR\" ng-click=\"faucetctrlfctplus()\"> <i class=\"fa fa-chevron-circle-right\" aria-hidden=\"true\"></i> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"bottomPipe\"> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"topPipe\"> \n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"toppipeArrow\">\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"bottompipeArrow\">\n\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t</div>\t\t\t\t\n\t\t\t\t</div>                             \n\t\t\t</div>\t\t\n\t\t\t<div class=\"mapblock\"> \n\t\t\t\t<div class=\"map\">\n\t\t\t\t\t<div class=\"point\" ng-style=\"{top: propFromTop, left: propFromLeft, transform: 'rotate('+ rotindeg +'deg)'}\">\n\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"tree\" ng-repeat=\"(key, value) in trees\" ng-style=\"{top: value.y, left: value.x}\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fire\" ng-repeat=\"(key, value) in firesloc\" ng-style=\"{top: value.y, left: value.x, opacity: opacityfire[key]}\">\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"loadlocB\" ng-style=\"{top: zones[1].y, left: zones[1].x}\">\n\t\t\t\t\t\t<i class=\"fa fa-battery-empty\" ng-show=\"iconBatt==0\"></i>\n\t\t\t\t\t\t<i class=\"fa fa-battery-quarter\" ng-show=\"iconBatt==1\"></i>\n\t\t\t\t\t\t<i class=\"fa fa-battery-half\" ng-show=\"iconBatt==2\"></i>\n\t\t\t\t\t\t<i class=\"fa fa-battery-three-quarters\" ng-show=\"iconBatt==3\"></i>\n\t\t\t\t\t\t<i class=\"fa fa-battery-full\" ng-show=\"iconBatt==4\"></i>\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"loadlocW\" ng-style=\"{top: zones[0].y, left: zones[0].x}\">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"waterlevelmap\" ng-style=\"{height: watlevelContainerMap + 'px'}\">\n\t\t\t\t\t\t</div>\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"warningsblock\"> \n\t\t\t\t<div class=\"title\"> ROBOT: </div>\n\t\t\t\t<div class=\"battery full\" ng-style=\"{width: battlevel+'%'}\"></div>\n\t\t\t\t<div class=\"gps\">\n\t\t\t\t\t<span>GPS</span>\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"waterlevel\">\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"waterempty\" ng-style=\"{height: watlevel+'px'}\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n-->\n"

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('videogameApp.constants', []).constant('appConfig', __webpack_require__(23)).name;

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('videogameApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Socket.$inject = ['socketFactory'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(27);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socket = __webpack_require__(29);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Socket(socketFactory) {
	  'ngInject';
	
	  var ioSocket = (0, _socket2.default)('', {
	    path: '/socket.io-client'
	  });
	
	  var socket = socketFactory({
	    ioSocket: ioSocket
	  });
	
	  return {
	    socket: socket,
	
	    syncUpdates: function syncUpdates(modelName, array, cb) {
	      cb = cb || _angular2.default.noop;
	
	      socket.on(modelName + ':save', function (item) {
	        var oldItem = _.find(array, {
	          _id: item._id
	        });
	        var index = array.indexOf(oldItem);
	        var event = 'created';
	
	        if (oldItem) {
	          array.splice(index, 1, item);
	          event = 'updated';
	        } else {
	          array.push(item);
	        }
	
	        cb(event, item, array);
	      });
	
	      socket.on(modelName + ':remove', function (item) {
	        var event = 'deleted';
	        _.remove(array, {
	          _id: item._id
	        });
	        cb(event, item, array);
	      });
	    },
	    unsyncUpdates: function unsyncUpdates(modelName) {
	      socket.removeAllListeners(modelName + ':save');
	      socket.removeAllListeners(modelName + ':remove');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('videogameApp.socket', []).factory('socket', Socket).name;

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(30);
	var parser = __webpack_require__(36);
	var Manager = __webpack_require__(46);
	var debug = __webpack_require__(32)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(46);
	exports.Socket = __webpack_require__(77);


/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(31);
	var debug = __webpack_require__(32)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),

/***/ 32:
[407, 34],

/***/ 33:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 34:
[408, 35],

/***/ 35:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(37)('socket.io-parser');
	var json = __webpack_require__(40);
	var Emitter = __webpack_require__(42);
	var binary = __webpack_require__(43);
	var isBuf = __webpack_require__(45);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(38);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(39);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(41);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)(module), (function() { return this; }())))

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(44);
	var isBuf = __webpack_require__(45);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(47);
	var Socket = __webpack_require__(77);
	var Emitter = __webpack_require__(78);
	var parser = __webpack_require__(36);
	var on = __webpack_require__(80);
	var bind = __webpack_require__(81);
	var debug = __webpack_require__(32)('socket.io-client:manager');
	var indexOf = __webpack_require__(75);
	var Backoff = __webpack_require__(82);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(48);


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(49);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(56);


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(50);
	var Emitter = __webpack_require__(65);
	var debug = __webpack_require__(69)('engine.io-client:socket');
	var index = __webpack_require__(75);
	var parser = __webpack_require__(56);
	var parseuri = __webpack_require__(31);
	var parsejson = __webpack_require__(76);
	var parseqs = __webpack_require__(66);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(55);
	Socket.transports = __webpack_require__(50);
	Socket.parser = __webpack_require__(56);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(51);
	var XHR = __webpack_require__(53);
	var JSONP = __webpack_require__(72);
	var websocket = __webpack_require__(73);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(52);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(51);
	var Polling = __webpack_require__(54);
	var Emitter = __webpack_require__(65);
	var inherit = __webpack_require__(67);
	var debug = __webpack_require__(69)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(55);
	var parseqs = __webpack_require__(66);
	var parser = __webpack_require__(56);
	var inherit = __webpack_require__(67);
	var yeast = __webpack_require__(68);
	var debug = __webpack_require__(69)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(51);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(56);
	var Emitter = __webpack_require__(65);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(57);
	var hasBinary = __webpack_require__(58);
	var sliceBuffer = __webpack_require__(60);
	var after = __webpack_require__(61);
	var utf8 = __webpack_require__(62);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(63);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(64);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(59);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 59:
44,

/***/ 60:
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)(module), (function() { return this; }())))

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),

/***/ 64:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),

/***/ 66:
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),

/***/ 69:
[407, 70],

/***/ 70:
[408, 71],

/***/ 71:
35,

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(54);
	var inherit = __webpack_require__(67);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(55);
	var parser = __webpack_require__(56);
	var parseqs = __webpack_require__(66);
	var inherit = __webpack_require__(67);
	var yeast = __webpack_require__(68);
	var debug = __webpack_require__(69)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(74);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(36);
	var Emitter = __webpack_require__(78);
	var toArray = __webpack_require__(79);
	var on = __webpack_require__(80);
	var bind = __webpack_require__(81);
	var debug = __webpack_require__(32)('socket.io-client:socket');
	var hasBin = __webpack_require__(58);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),

/***/ 78:
65,

/***/ 79:
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AboutComponent = undefined;
	
	var _about = __webpack_require__(84);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var AboutComponent =
	/*@ngInject*/
	exports.AboutComponent = ['$http', '$scope', 'socket', function AboutComponent($http, $scope, socket) {
	  'ngInject';
	
	  _classCallCheck(this, AboutComponent);
	
	  this.$http = $http;
	  this.socket = socket;
	}];
	
	exports.default = angular.module('robotfirefighterApp.about', [uiRouter]).config(_about2.default).component('about', {
	  template: __webpack_require__(85),
	  controller: AboutComponent,
	  controllerAs: 'aboutCtrl'
	}).name;

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('about', {
	    url: '/about',
	    template: '<about></about>'
	  });
	}];

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	module.exports = "<div class=\"pageAbout\">\n\t<div class=\"poster\"> </div>\n</div>\n"

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WelcomeComponent = undefined;
	
	var _welcome = __webpack_require__(87);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var WelcomeComponent =
	/*@ngInject*/
	exports.WelcomeComponent = ['$http', '$scope', 'socket', 'sharedProperties', '$rootScope', '$interval', function WelcomeComponent($http, $scope, socket, sharedProperties, $rootScope, $interval) {
	  'ngInject';
	
	  _classCallCheck(this, WelcomeComponent);
	
	  if (!$rootScope.language) {
	    $rootScope.language = 'english';
	  }
	  this.$http = $http;
	  this.socket = socket;
	
	  var debug = false;
	
	  var remainingTimeInterval = $interval(function () {
	    $http.get('/api/control/time').then(function (response) {
	      if (response.status === 200) {
	        $scope.remainingtime = response.data;
	      }
	    });
	
	    $http.get('/api/auth').then(function (response) {
	      if (debug) {
	        console.log(response);
	        console.log("emptySlot:");
	        console.log(response.data);
	      }
	      $scope.emptySlot = response.data;
	    });
	  }, 1000);
	  $scope.$on("$destroy", function () {
	    if (remainingTimeInterval) {
	      $interval.cancel(remainingTimeInterval);
	    }
	  });
	
	  $rootScope.token = "";
	  var myToken = $rootScope.token;
	  $scope.play = function () {
	    $http.get('/api/auth/play').then(function (response) {
	      if (debug) {
	        console.log("response!");
	        console.log(response);
	      }
	      if (response.status === 200) {
	        if (debug) {
	          console.log("give token");
	        }
	
	        $rootScope.token = response.data;
	        myToken = $rootScope.token;
	        if (debug) {
	          console.log("welcome - play() -- I JUST GOT A TOKEN: ");
	          console.log($rootScope.token);
	          console.log("welcome - play() -- myToken : ");
	          console.log(myToken);
	        }
	
	        $http.post('/api/control/start', { token: myToken }).then(function (response) {
	          if (debug) {
	            console.log("control/start response:");
	            console.log(response);
	          }
	          if (response.status === 200) {
	            if (debug) {
	              console.log("game launched!");
	            }
	          } else if (debug) {
	            console.log("game not launched");
	          }
	        });
	      } else {
	        $scope.emptySlot = false;
	        if (debug) {
	          console.log("no token available!");
	        }
	      }
	    });
	  };
	
	  $scope.language = $rootScope.language || 'english';
	
	  $scope.french = function () {
	    $rootScope.language = 'french';
	    console.log($rootScope.language);
	    $scope.language = 'french';
	  };
	  $scope.english = function () {
	    $rootScope.language = 'english';
	    $scope.language = 'english';
	    console.log($rootScope.language);
	  };
	}];
	
	exports.default = angular.module('videogameApp.welcome', [uiRouter]).config(_welcome2.default).component('welcome', {
	  template: __webpack_require__(88),
	  controller: WelcomeComponent,
	  controllerAs: 'welcomeCtrl'
	}).name;

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('welcome', {
	    url: '/welcome',
	    template: '<welcome></welcome>'
	  });
	}];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"page\">\n\t<div class=\"mainmsgs\">\n\t\t<div class=\"titleWelcome\" ng-if=\"language=='english'\"> Welcome to the HoRIzON webpage </div>\n\t\t<div class=\"titleWelcome\" ng-if=\"language=='english'\"> hosting the <span class=\"bold\"> FIREFIGHTER ROBOT GAME </span> </div>\n\t\t<div class=\"titleWelcome\" ng-if=\"language=='french'\"> Bienvenue sur la page web du projet HoRIzon</div>\n\t\t<div class=\"titleWelcome\" ng-if=\"language=='french'\"> le <span class=\"bold\"> JEU DU ROBOT POMPIER </span> vous attend ! </div>\n\t</div>\n\t<div class=\"mainmsgsrules\">\n\t\t<div class=\"mainmsg\" ng-if=\"language=='english'\"> <span> Try to fight fires </span> <div class=\"fireicon\"> </div> <span> with a ground robot </span> <div class=\"brain\"> </div> </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='english'\"> <span> by controlling it </span> <div class=\"keyboard\"> </div> <span> when it loses its autonomy </span> </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='english'\"> <span> and by managing its water tank </span> <div class=\"tapwater\"> </div>  </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='english'\"> <div> <i class=\"fa fa-wifi\" aria-hidden=\"true\"></i> </div> <span> &nbsp; You need a good internet connection! </span> </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='french'\"> <span> Essayez d'éteindre les feux </span> <div class=\"fireicon\"> </div> <span> avec un robot terrestre </span> <div class=\"brain\"> </div> </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='french'\"> <span> en le controlant </span> <div class=\"keyboard\"> </div> <span> lorsqu'il perd son autonomie </span> </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='french'\"> <span> et en gérant ses réserves d'eau </span> <div class=\"tapwater\"> </div>  </div>\n\t\t<div class=\"mainmsg\" ng-if=\"language=='french'\"> <div> <i class=\"fa fa-wifi\" aria-hidden=\"true\"></i> </div> <span> &nbsp; Vous avez besoin d'une bonne connection internet ! </span> </div> \n\t</div>\n\t<div class=\"mainBand\">\n\t\t<div class=\"mainButton\" ui-sref=\"howto\" ng-if=\"language=='english'\"> RULES </div>\n\t\t<div class=\"mainButton\" ui-sref=\"howto\" ng-if=\"language=='french'\"> REGLES </div>\n\t\t<div class=\"mainButton\" ui-sref=\"train\" ng-if=\"language=='english'\"> TRAIN </div>\n\t\t<div class=\"mainButton\" ui-sref=\"train\" ng-if=\"language=='french'\"> ENTRAINEMENT </div>\t\t\n\t\t<div class=\"mainButton\" ui-sref=\"loading\" ng-click=\"play()\" ng-if=\"emptySlot && language=='english'\"> PLAY </div>\n\t\t<div class=\"mainButton\" ui-sref=\"loading\" ng-click=\"play()\" ng-if=\"emptySlot && language=='french'\"> JOUER </div>\n\n                <div class=\"timeBeforePlaying\" ng-if=\"!emptySlot\"> \n\t\t\t<span class=\"notegame\" ng-if=\"language=='english'\"> Someone is playing: the game will be available in {{remainingtime || \"few\"}} seconds. </span>\n\t\t\t<span class=\"notegame\" ng-if=\"language=='french'\"> Quelqu'un joue actuellement : le jeu sera disponible dans {{remainingtime || \"few\"}} secondes. </span> \n\t\t</div>\n<!--\t\t<div class=\"mainButton\" ui-sref=\"game\" ng-if=\"!emptySlot\"> SEE </div> -->\t\t\n\t\t\n\t\t<div class=\"mainButton\" ui-sref=\"scores\"> SCORES </div>\t\t\n\t\t<div class=\"mainButton\" ui-sref=\"about\" ng-if=\"language=='english'\"> ABOUT </div>\n\t\t<div class=\"mainButton\" ui-sref=\"about\" ng-if=\"language=='french'\"> A PROPOS </div>\n\t</div>\n\t<div class=\"notegame\" ng-if=\"language=='english'\"> This crowdsourcing platform has been developped by the department\n<a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/research/departments/department-of-aerospace-vehicles-design-and-control-dcas-95/department-of-aerospace-vehicles-design-and-control-dcas/\">DCAS</a>\n of <a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/\">ISAE-SUPAERO</a> in the context of the     <a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/isae-supaero/mecenat-relations-avec-la-fondation-isae-supaero/chaire-dassault-aviation/\">Dassault Aviation chair</a>. </div>\n\t<div class=\"notegame\" ng-if=\"language=='french'\"> Cette plate-forme de collecte de données participative a été développée par le département \n<a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/research/departments/department-of-aerospace-vehicles-design-and-control-dcas-95/department-of-aerospace-vehicles-design-and-control-dcas/\">DCAS</a>\n de l'<a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/\">ISAE-SUPAERO</a> dans le contexte de la <a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/en/isae-supaero/mecenat-relations-avec-la-fondation-isae-supaero/chaire-dassault-aviation/\">chaire Dassault Aviation</a>. </div>\n\t<div class=\"logos\">\n\t\t<div class=\"languages\">\n\t\t\t<div class=\"language\" ng-click=\"french()\"> <span class=\"bold\"> FRANCAIS </span> </div>\n\t\t\t<div class=\"language\" ng-click=\"english()\"><span class=\"bold\"> ENGLISH </span> </div>\n\t\t</div>\n\t\t<div class=\"logosclose\"> \n\t\t\t<div class=\"dassault\"> </div>   <!-- ui-sref=\"experiment\" --> \n\t\t\t<div class=\"supaero\"> </div> \n\t\t</div>\n\t</div>\n\t<div class=\"allThanks\">\n\t\t<div class=\"thanks\" ng-if=\"language=='english'\"> \n\t\t\tBy <span class=\"bold\"> Nicolas Drougard</span>. \n\t\t\tMany thanks to Corentin Chauffaut and Pascal Chauvin for the robotic framework, \n\t\t\tto Christophe Garcia for the web hosting (firstname.name@isae-supaero.fr), \n\t\t\tand to Mario Cassaro for the water management task design (firstname.name@onera.fr). \n\t\t\tAlso many thanks to Jonathan Carbasse for his great help with angular fullstack (firstname.name@gmail.com). \n\t\t\tThanks to EmojiOne for providing free emoji icons. Font Awesome by Dave Gandy - http://fontawesome.io \n\t\t</div> \n\t\t<div class=\"thanks\" ng-if=\"language=='french'\"> \n\t\t\tPar <span class=\"bold\"> Nicolas Drougard</span>. \n\t\t\tUn grand merci à Corentin Chauffaut et Pascal Chauvin pour la partie robotique, \n\t\t\tà Christophe Garcia pour l'hébergement web (prenom.nom@isae-supaero.fr), \n\t\t\tet à Mario Cassaro pour le module de gestion de l'eau (prenom.nom@onera.fr). \n\t\t\tUn grand merci aussi à Jonathan Carbasse pour son aide précieuse avec angular fullstack (prenom.nom@gmail.com). \n\t\t\tMerci à EmojiOne pour les emojis. Font Awesome par Dave Gandy - http://fontawesome.io\n\t\t</div>\n</div>\n"

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingComponent = undefined;
	
	var _loading = __webpack_require__(90);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var LoadingComponent =
	/*@ngInject*/
	exports.LoadingComponent = ['$http', '$scope', 'socket', '$interval', '$timeout', 'sharedProperties', '$rootScope', '$window', function LoadingComponent($http, $scope, socket, $interval, $timeout, sharedProperties, $rootScope, $window) {
	  'ngInject';
	
	  _classCallCheck(this, LoadingComponent);
	
	  $scope.language = $rootScope.language || 'english';
	  $scope.user = {};
	  $scope.user.pseudo = "";
	  var myToken = $rootScope.token;
	  $scope.playEnabled = false;
	  $scope.lostGame = false;
	  this.$http = $http;
	  this.socket = socket;
	  $scope.dot = 0;
	  var debug = false;
	  var servercall = $interval(function () {
	    myToken = $rootScope.token;
	    if (debug) {
	      console.log("$rootScope.token");
	      console.log($rootScope.token);
	    }
	    $http.post('/api/auth/gameready', { token: myToken }).then(function (response) {
	      if (response.status === 200) {
	        if (debug) {
	          console.log(response.data.isgameready);
	          console.log(response.data.istoolate);
	        }
	        if (response.data.isgameready || $scope.playEnabled) {
	          $scope.playEnabled = true;
	        }
	        if (response.data.istoolate || $scope.lostGame) {
	          $scope.lostGame = true;
	          $scope.playEnabled = false;
	        }
	      }
	    });
	    $scope.dot = ($scope.dot + 1) % 4;
	    console.log("LOADING VARIABLES");
	    console.log("$scope.lostGame");
	    console.log($scope.lostGame);
	    console.log("$scope.playEnabled");
	    console.log($scope.playEnabled);
	    if ($scope.playEnabled) {
	      $http.post('/api/control/pseudobegin', { pseudo: $scope.user.pseudo, token: myToken }).then(function (response) {
	        if (response.status === 200) {
	          console.log($scope.user.pseudo);
	          console.log("!!!!!!! new pseudo sent !!!!!!!!");
	        } else {
	          console.log('nok pseudo');
	        }
	      });
	    }
	  }, 1000);
	
	  $scope.$on("$destroy", function () {
	    if (servercall) {
	      var cancelServerCall = $interval.cancel(servercall);
	      if (debug) {
	        console.log("SERVERCALL INTERVAL KILL:");
	        console.log(cancelServerCall);
	      }
	    }
	  });
	
	  if (debug) {
	    console.log("LOADING!");
	    console.log("$rootScope.token:");
	    console.log($rootScope.token);
	    console.log("myToken:");
	    console.log(myToken);
	  }
	
	  $scope.letsplay = function () {
	    myToken = $rootScope.token;
	    if (debug) {
	      console.log("letsplay!");
	      console.log("myToken:");
	      console.log(myToken);
	      console.log("$rootScope.token:");
	      console.log($rootScope.token);
	    }
	
	    if (debug) {
	      console.log("post token to control/launchgame");
	    }
	    $http.post('/api/control/launchgame', { token: myToken }).then(function (response) {
	      if (debug) {
	        console.log("letsplay -- control/launchgame -- response: ");
	        console.log(response);
	      }
	      if (response.status === 200) {
	        if (debug) {
	          console.log("le token est ok, la partie js du jeu est lancée");
	
	          console.log("post token to auth/killTimeout");
	        }
	        $http.post('/api/auth/killtimeout', { token: myToken }).then(function (response) {
	          if (debug) {
	            console.log("letsplay -- auth/killTimeout -- response: ");
	            console.log(response);
	          }
	          if (response.status === 200) {
	            if (debug) {
	              console.log("le token est ok, timeout annulé dans auth");
	            }
	          } else if (debug) {
	            console.log('nok');
	          }
	        });
	      } else if (debug) {
	        console.log('nok');
	      }
	    });
	  };
	
	  $scope.reload = function () {
	    $timeout(function () {
	      $window.location.reload();
	    }, 500);
	  };
	}];
	
	exports.default = angular.module('robotfirefighterApp.loading', [uiRouter]).config(_loading2.default).component('loading', {
	  template: __webpack_require__(91),
	  controller: LoadingComponent,
	  controllerAs: 'loadingCtrl'
	}).name;

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('loading', {
	    url: '/loading',
	    template: '<loading></loading>'
	  });
	}];

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"loading\">\n\t<div class=\"loadpart\" ng-if=\"!playEnabled && !lostGame\">\n\t\t<span ng-if=\"language=='english'\"> LOADING <span ng-if=\"dot>0\">.</span><span ng-if=\"dot>1\">.</span><span ng-if=\"dot>2\">.</span></span>\n\t\t<span ng-if=\"language=='french'\"> CHARGEMENT <span ng-if=\"dot>0\">.</span><span ng-if=\"dot>1\">.</span><span ng-if=\"dot>2\">.</span></span>\n\t</div>\n        <div class=\"loadpart2\" ng-if=\"playEnabled && !lostGame\">\n\t\t<span style=\"color: #05BDFF\" ng-if=\"user.pseudo!='' && language=='english'\"> Hi {{user.pseudo}}! </span>\n\t\t<span style=\"color: #05BDFF\" ng-if=\"user.pseudo!='' && language=='french'\"> Salut {{user.pseudo}}! </span>\n\t\t<span ng-if=\"language=='english'\"> The game is ready! </span>\n\t\t<span ng-if=\"language=='french'\"> Le jeu est prêt ! </span>\n\t</div>\n\t<div class=\"loadpart\" ng-if=\"lostGame\">\n\t\t<span ng-if=\"language=='english'\"> TOO LATE, SORRY! </span>\n\t\t<span ng-if=\"language=='french'\"> TROP TARD, désolé ! </span>\n\t</div>\n\t<!-- <span class=\"advice\"> Press F11 for a better experience </span> -->\n\t<span class=\"advice\" ng-if=\"!lostGame && language=='english'\"> Please do not refresh web pages from now! </span>\n\t<span class=\"advice\" ng-if=\"!lostGame && language=='french'\"> S'il vous plaît ne rafraîchissez pas les pages webs à partir de maintenant. </span>\n        <span class=\"advice\" ng-if=\"!lostGame && !playEnabled && language=='english'\"> Enter your pseudo if you want to display it on the score page: <input type=\"text\" maxlength=\"10\" ng-model=\"user.pseudo\" /> </span>\n        <span class=\"advice\" ng-if=\"!lostGame && !playEnabled && language=='french'\"> Ecrivez votre pseudo si vous souhaitez le voir apparaître dans la page de scores: <input type=\"text\" maxlength=\"10\" ng-model=\"user.pseudo\" /> </span>\n\t<div class=\"reminders\" ng-if=\"!playEnabled && !lostGame\">\n\t\t<div class=\"watermanagementLoading\">\n\t\t\t<div ng-if=\"language=='english'\"> <i class=\"fa fa-tint\" aria-hidden=\"true\"></i> Ground tank water management: </div>\n\t\t\t<div ng-if=\"language=='french'\"> <i class=\"fa fa-tint\" aria-hidden=\"true\"></i> Gestion de l'eau du réservoir principal: </div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"mainbuttonL\">\n\t\t\t\t\t<i class=\"fa fa-undo\" aria-hidden=\"true\"></i>\n\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\"> or </div>\n\t\t\t\t<div ng-if=\"language=='french'\"> ou </div>\n\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t<div style=\"color: black\"> s </div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\" class=\"result\"> increase wheel's speed <br /> to the left</div>\n\t\t\t\t<div ng-if=\"language=='french'\" class=\"result\"> augmente la vitesse de la roue <br /> vers la gauche</div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\t\n\t\t\t\t<div class=\"mainbuttonR\"> \n\t\t\t\t\t<i class=\"fa fa-undo\" aria-hidden=\"true\"></i>\n\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\"> or </div>\n\t\t\t\t<div ng-if=\"language=='french'\"> ou </div>\n\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t<div style=\"color: black\"> d </div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\" class=\"result\"> increase wheel's speed <br /> to the right </div>\n\t\t\t\t<div ng-if=\"language=='french'\" class=\"result\"> augmente la vitesse de la roue <br /> vers la droite </div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"pushButton\">\n\t\t\t\t\t<div class=\"buttonTap\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\"> or </div>\n\t\t\t\t<div ng-if=\"language=='french'\"> ou </div>\n\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t<div style=\"color: black\"> e </div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\" class=\"result\"> tap opens few seconds </div>\n\t\t\t\t<div ng-if=\"language=='french'\" class=\"result\"> le robinet s'ouvre quelques secondes </div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"wrenchButton\">\n\t\t\t\t\t<i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\"> or </div>\n\t\t\t\t<div ng-if=\"language=='french'\"> ou </div>\n\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t<div style=\"color: black\"> a </div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"language=='english'\" class=\"result\"> allows to fix leaks </div>\n\t\t\t\t<div ng-if=\"language=='french'\" class=\"result\"> permet de réparer les fuites </div>\n\t\t\t</div>\t\t\t\t\n\t\t</div>\n\t\t<div class=\"robotControlLoading\">\n\t\t\t<div ng-if=\"language=='english'\"> <i class=\"fa fa-gamepad\" aria-hidden=\"true\"></i> Control of the robot: </div>\n\t\t\t<div ng-if=\"language=='french'\"> <i class=\"fa fa-gamepad\" aria-hidden=\"true\"></i> Contrôle du robot : </div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"spaceKey\">\n\t\t\t\t\t<div ng-if=\"language=='english'\" style=\"color: black\"> SPACE </div>\n\t\t\t\t\t<div ng-if=\"language=='french'\" style=\"color: black\"> ESPACE </div>\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"littlesplatch\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"centeranykey\">\n\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t<div style=\"color: black\"> <i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arrowFor\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"centeranykey\">\n\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t<div style=\"color: black\"> <i class=\"fa fa-arrow-down\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arrowBack\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"centeranykey\">\n\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t<div style=\"color: black\"> <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arrowLeft\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"explainkeys\">\n\t\t\t\t<div class=\"centeranykey\">\n\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t<div style=\"color: black\"> <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arrowRight\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--<div ng-if=\"emptySlot\">\n\t\t\t\tSlot libre\n\t\t\t\t<button ng-click=\"play()\">Jouer</button>\n\t\t\t</div>-->\n\t\t</div>\n\t</div>\n\t<div class=\"letsplaybutton\" ui-sref=\"game\"  ui-sref-opts=\"{reload: true}\" ng-if=\"playEnabled && !lostGame && language=='english'\" ng-click=\"letsplay()\"> Click here to play! </div>\n\t<div class=\"letsplaybutton\" ui-sref=\"game\"  ui-sref-opts=\"{reload: true}\" ng-if=\"playEnabled && !lostGame && language=='french'\" ng-click=\"letsplay()\"> Clique ici pour jouer ! </div>\n\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"lostGame && language=='english'\" ng-click=\"reload()\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> back to main menu </div>\n\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"lostGame && language=='french'\" ng-click=\"reload()\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> retour au menu principal </div>\n</div>\n"

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HowtoComponent = undefined;
	
	var _howto = __webpack_require__(93);
	
	var _howto2 = _interopRequireDefault(_howto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var HowtoComponent =
	/*@ngInject*/
	exports.HowtoComponent = ['$scope', '$rootScope', function HowtoComponent($scope, $rootScope) {
	  'ngInject';
	
	  _classCallCheck(this, HowtoComponent);
	
	  this.message = 'Hello';
	  $scope.language = $rootScope.language || 'english';
	}];
	
	exports.default = angular.module('robotfirefighterApp.howto', [uiRouter]).config(_howto2.default).component('howto', {
	  template: __webpack_require__(94),
	  controller: HowtoComponent,
	  controllerAs: 'howtoCtrl'
	}).name;

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('howto', {
	    url: '/howto',
	    template: '<howto></howto>'
	  });
	}];

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"howto\"> \n\t<span class=\"titlehowto\" ng-if=\"language=='english'\"> Context: </span> \n\t<span class=\"titlehowto\" ng-if=\"language=='french'\"> Contexte: </span> \n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-android\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> A firefighter robot is present in a small area </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> Un robot pompier se trouve dans une petite zone </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-tree\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span>  with few trees  </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span>  avec quelques arbres  </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-fire\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span>  which have a weird tendency to self-ignite for some unknown reason... </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span>  ayant une facheuse tendance à prendre feu pour une raison inconnue... </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-location-arrow\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> Through your graphical interface, you get the position of the robot, </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> Grâce à l'interface graphique, vous observez la position du robot, </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> as well as the video from its camera. </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> ainsi que la vidéo générée par sa caméra. </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-battery-three-quarters\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> The battery charge level of the robot decreases with time: when the robot is on the red square, the battery recharges. </span> \n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> Le niveau de baterie du robot diminue avec le temps : lorsque le robot est sur le carré rouge, la baterie se recharge. </span> \n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> The volume of water contained by the robot is not unlimited: to recharge its water tank, the robot has to be placed on the blue square and the ground tank has to be full enough. For that, you have to fill the ground tank using the buttons on the left-side of the interface. </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> Le volume d'eau contenu par le robot n'est pas illimité : pour le recharger en eau, le robot doit être placé sur le carré bleu et le réservoir principal doit être assez rempli. Pour cela, vous devez remplir le réservoir principal en utilisant les boutons à gauche de l'interface. </span>\n\t\t</div>\n\t</div>\n\t<span class=\"titlehowto\" ng-if=\"language=='english'\"> Goal: </span>\n\t<span class=\"titlehowto\" ng-if=\"language=='french'\"> But: </span>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t\t<span> With the help of this robot, your mission is to fight as much fires as you can. </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t\t<span> Avec l'aide de ce robot, votre mission est d'éteindre le plus de feux possible. </span>\n\t\t</div>\n\t</div>\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-play\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t<span> The robot can become autonomous at any time. </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t<span> Le robot peut devenir autonome à n'importe quel moment. </span>\n\t\t</div>\n\t</div>\n\n\t<div class=\"rowhowto\">\n\t\t<div class=\"leftpartrow\">\n\t\t\t<i class=\"fa fa-thermometer-three-quarters\" aria-hidden=\"true\"></i>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='english'\">\n\t\t<span> Pay attention to the robot's temperature when it is too close of flames!  </span>\n\t\t</div>\n\t\t<div class=\"rightpartrow\" ng-if=\"language=='french'\">\n\t\t<span> Faites attention à la température du robot lorsqu'il est trop proche des flammes !</span>\n\t\t</div>\n\t</div>\n\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='english'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> back to main menu </div>\n\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='french'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> retour au menu principal</div>\n<!--\t<button ui-sref=\"welcome\"> BACK </button> -->\n</div>\n"

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TrainComponent = undefined;
	
	var _train = __webpack_require__(96);
	
	var _train2 = _interopRequireDefault(_train);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var TrainComponent =
	/*@ngInject*/
	exports.TrainComponent = ['$http', '$scope', 'socket', 'hotkeys', '$interval', '$rootScope', function TrainComponent($http, $scope, socket, hotkeys, $interval, $rootScope) {
	
	  'ngInject';
	
	  _classCallCheck(this, TrainComponent);
	
	  $scope.language = $rootScope.language || 'english';
	
	  hotkeys.add({
	    combo: 's',
	    description: 'tapleft',
	    callback: function callback() {
	      $scope.faucetctrlfctminus();
	    }
	  });
	
	  hotkeys.add({
	    combo: 'd',
	    description: 'tapright',
	    callback: function callback() {
	      $scope.faucetctrlfctplus();
	    }
	  });
	
	  hotkeys.add({
	    combo: 'e',
	    description: 'pushbutton',
	    callback: function callback() {
	      $scope.waterPushButton();
	    }
	  });
	
	  hotkeys.add({
	    combo: 'a',
	    description: 'wrench',
	    callback: function callback() {
	      $scope.wrenchOnOff();
	    }
	  });
	
	  $scope.xrobinet = 42;
	  $scope.watlevelContainer = 50;
	  var decal = 4;
	  var coeffXrob = 10;
	  var constXrob = 50;
	
	  $scope.faucetcontrol = 0;
	
	  var leakPlacesNb = 9;
	  $scope.leakPlaces = [];
	  $scope.noleakat = [];
	  var leakCounter = 0;
	  for (var i = 0; i < leakPlacesNb; i++) {
	    $scope.leakPlaces.push(leakCounter);
	    leakCounter++;
	    $scope.noleakat.push(true);
	  }
	
	  var pivalue = 3.1415;
	  var coeffspeed = 20;
	  var faucetxaxis = 2 * 10 / 40;
	
	  var waterManagementInterval = $interval(function () {
	    if ($scope.xrobinet <= 80 && $scope.xrobinet >= 0) {
	      $scope.xrobinet = $scope.xrobinet + coeffspeed * (pivalue / 80) * Math.sin(pivalue * $scope.xrobinet / 40 - pivalue) + $scope.faucetcontrol;
	    } else if ($scope.xrobinet > 80) {
	      $scope.xrobinet = 80;
	    } else if ($scope.xrobinet < 0) {
	      $scope.xrobinet = 0;
	    }
	    $scope.xrobinetwater = $scope.xrobinet + decal;
	    var fxa = ($scope.xrobinet - 40) * 10 / 40;
	    faucetxaxis = fxa;
	    $scope.yrobinet = coeffXrob * Math.cos(faucetxaxis * 3.1415 * 2 / 20) + constXrob;
	  }, 200);
	
	  var waterFlowInterval = $interval(function () {
	    var leaksSum = 0;
	    for (var i = 0; i < leakPlacesNb; i++) {
	      if (!$scope.noleakat[i]) {
	        leaksSum = leaksSum + 1;
	      }
	    }
	    if (faucetxaxis < 2 && faucetxaxis > -2 && $scope.watlevelContainer <= 100) {
	      $scope.watlevelContainer = $scope.watlevelContainer + $scope.waterwidth * 10 / 7 - leaksSum / (2 * leakPlacesNb);
	    } else if ($scope.watlevelContainer > 1) {
	      $scope.watlevelContainer = $scope.watlevelContainer - leaksSum / leakPlacesNb;
	    }
	  }, 200);
	
	  $scope.leaksReverse = [];
	  $scope.leftValues = [0, 0, 0, 0, 0, 0, 0, 0, 0];
	  var previousNoleakat = [true, true, true, true, true, true, true, true, true];
	  var leaksInterval = $interval(function () {
	    if (Math.random() < 0.5) {
	      var myInt = Math.floor(Math.random() * leakPlacesNb);
	      $scope.noleakat[myInt] = false;
	    }
	
	    for (var i = 0; i < $scope.leakPlaces.length; i++) {
	      if (!$scope.noleakat[i] && previousNoleakat[i]) {
	        if (Math.random() > 0.5) {
	          $scope.leaksReverse[i] = -1;
	        } else {
	          $scope.leaksReverse[i] = 1;
	        }
	        $scope.leftValues[i] = Math.random() * 30;
	        previousNoleakat[i] = $scope.noleakat[i];
	      }
	    }
	  }, 5000);
	
	  $scope.$on("$destroy", function () {
	    if (leaksInterval) {
	      $interval.cancel(leaksInterval);
	    }
	    if (waterFlowInterval) {
	      $interval.cancel(waterFlowInterval);
	    }
	    if (waterManagementInterval) {
	      $interval.cancel(waterManagementInterval);
	    }
	  });
	
	  $scope.faucetcontrolShow = 0;
	  $scope.direction = 0;
	  $scope.animtime = 0;
	  $scope.faucetctrlfctplus = function () {
	    if ($scope.faucetcontrol < 3) {
	      $scope.faucetcontrol = $scope.faucetcontrol + 1;
	      $scope.faucetcontrolShow = $scope.faucetcontrol;
	      if ($scope.faucetcontrol > 0) {
	        $scope.faucetcontrolShow = '+' + $scope.faucetcontrol;
	      }
	      if ($scope.faucetcontrol > 0) {
	        $scope.direction = 1;
	      } else if ($scope.faucetcontrol < 0) {
	        $scope.direction = -1;
	      } else {
	        $scope.direction = 0;
	      }
	      $scope.animtime = 7 - Math.abs($scope.faucetcontrol) * 2;
	    }
	  };
	
	  $scope.faucetctrlfctminus = function () {
	    if ($scope.faucetcontrol > -3) {
	      $scope.faucetcontrol = $scope.faucetcontrol - 1;
	      $scope.faucetcontrolShow = $scope.faucetcontrol;
	      if ($scope.faucetcontrol > 0) {
	        $scope.faucetcontrolShow = '+' + $scope.faucetcontrol;
	      }
	      if ($scope.faucetcontrol > 0) {
	        $scope.direction = 1;
	      } else if ($scope.faucetcontrol < 0) {
	        $scope.direction = -1;
	      } else {
	        $scope.direction = 0;
	      }
	      $scope.animtime = 10 - Math.abs($scope.faucetcontrol) * 3;
	    }
	  };
	
	  var repeater;
	  $scope.waterwidth = 0;
	  $scope.waterPushButton = function () {
	    $scope.waterwidth = 7 / 10;
	    var callCount = 1;
	    clearInterval(repeater);
	    repeater = setInterval(function () {
	      if (callCount < 8) {
	        $scope.waterwidth = (7 - callCount) / 10;
	        callCount += 1;
	      } else {
	        clearInterval(repeater);
	      }
	    }, 1000);
	  };
	
	  $scope.wrenchmodeTrain = false;
	  $scope.wrenchOnOff = function () {
	    $scope.wrenchmodeTrain = !$scope.wrenchmodeTrain;
	  };
	
	  $scope.clickLeak = function (leakId) {
	    if ($scope.wrenchmodeTrain) {
	      $scope.noleakat[leakId] = true;
	      $scope.wrenchmodeTrain = false;
	    }
	  };
	}];
	
	exports.default = angular.module('robotfirefighterApp.train', [uiRouter]).config(_train2.default).component('train', {
	  template: __webpack_require__(97),
	  controller: TrainComponent,
	  controllerAs: 'trainCtrl'
	}).name;

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('train', {
	    url: '/train',
	    template: '<train></train>'
	  });
	}];

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"train\"  ng-class=\"{'screenWrenchTrain': wrenchmodeTrain}\">\n\t<div class=\"screenTrain\">\n\t\t<div class=\"twoparts\">\n\t\t\t<div class=\"watermngttrain\">\n\t\t\t\t<div class=\"waterBlocktrain\">\n\t\t\t\t\t<div class=\"maincontainer\">\n\t\t\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t\t\t<i style=\"color: #05BDFF;\" class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"robinetcontainer\">\n\t\t\t\t\t\t\t<div class=\"arrowShowing\"> <i class=\"fa fa-arrow-down\" aria-hidden=\"true\"></i> </div>\n\t\t\t\t\t\t\t<div class=\"robinet\" ng-style=\"{left: xrobinet+2+'%', bottom: yrobinet/1.8 + 46 +'%'}\"> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction!=0\" ng-class=\"{wheelinverse: direction<0}\"  ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+60+'%', 'animation-duration': animtime + 's'}\"> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction==0\" ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+60+'%'}\"> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"string\" ng-style=\"{left: xrobinet+11.5+'%', bottom: yrobinet/1.8+54+'%'}\"> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"robinetwaterContainer\" ng-style=\"{left: xrobinetwater-0.6+'%', bottom: yrobinet/1.8 + 41 +'%'}\">\n\t\t\t\t\t\t\t\t<div class=\"robinetwater\" ng-style=\"{width: waterwidth + 'vw', 'background-size': waterwidth + 'vw 1vw'}\">\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"montainAxis\"> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"neckcontainer\">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"tankcontainer\">\t\n\t\t\t\t\t\t\t\t<div class=\"tankcontainerwaterpart\">\n\t\t\t\t\t\t\t\t\t<div class=\"tankcontainerwaterviz\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"graduations\"> </div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"tankcontainerwater\" ng-style=\"{height: watlevelContainer + '%'}\"> \n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t\t\t<div class=\"tankcontainerleakspart\">\n\t\t\t\t\t\t\t\t\t<div class=\"wrapLeaks\">\n\t\t\t\t\t\t\t\t\t<div class=\"leakContainer\" ng-repeat=\"(key, value) in leakPlaces\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[key]}\" ng-style=\"{'transform': 'scale(' + leaksReverse[key] + ', 1)', 'left': leftValues[key] + '%'}\"  ng-click=\"clickLeak(key)\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"legsContainer\">\n\t\t\t\t\t\t\t\t\t<div class=\"legs\">\n\t\t\t\t\t\t\t\t\t</div>                           \t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"wmbuttons\">\n\t\t\t\t\t\t\t\t<!-- <i class=\"fa fa-mouse-pointer\" aria-hidden=\"true\"></i> -->\n\t\t\t\t\t\t\t\t<div class=\"speed\">  \n\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall2\"> </div> \n\t\t\t\t\t\t\t\t\t<div ng-if=\"language=='english'\"> speed: {{faucetcontrolShow}} </div>\n\t\t\t\t\t\t\t\t\t<div ng-if=\"language=='french'\"> vitesse: {{faucetcontrolShow}} </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"buttonWheel\">\n\t\t\t\t\t\t\t\t\t<div class=\"buttonChar\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"mainbuttonL\" ng-class=\"{'cursorPointer': !wrenchmodeTrain}\" ng-click=\"faucetctrlfctminus()\"> \n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-undo\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"char\"> s </div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"mainbuttonR\" ng-class=\"{'cursorPointer': !wrenchmodeTrain}\" ng-click=\"faucetctrlfctplus()\"> \n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-undo\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"char\"> d </div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t\t\t<div class=\"pushButton\" ng-class=\"{'cursorPointer': !wrenchmodeTrain}\" ng-click=\"waterPushButton()\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"buttonTap\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"char\"> e </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t\t\t<div class=\"wrenchButton\" ng-class=\"{'cursorPointer': !wrenchmodeTrain}\" ng-click=\"wrenchOnOff()\">\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"char\"> a </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"robotcommandstrain\">\n\t\t\t\t<div class=\"robotblocktrain\">\n\t\t\t\t\t<div class=\"maincontainer\">\n\t\t\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t\t\t<i style=\"color: #05BDFF;\" class=\"fa fa-gamepad\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"robotControl\">\n\t\t\t\t\t\t\t<div class=\"explainkeys\">\n\t\t\t\t\t\t\t\t<div class=\"littlesplatch\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"spaceKey\">\n\t\t\t\t\t\t\t\t\t<div ng-if=\"language=='english'\"> SPACE </div>\t\n\t\t\t\t\t\t\t\t\t<div ng-if=\"language=='french'\"> ESPACE </div>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"explainkeys\">\n\t\t\t\t\t\t\t\t<div class=\"arrowFor\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t\t\t\t<div> <i class=\"fa fa-arrow-up\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"explainkeys\">\n\t\t\t\t\t\t\t\t<div class=\"arrowBack\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t\t\t\t<div> <i class=\"fa fa-arrow-down\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"explainkeys\">\n\t\t\t\t\t\t\t\t<div class=\"arrowLeft\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t\t\t\t<div> <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"explainkeys\">\n\t\t\t\t\t\t\t\t<div class=\"arrowRight\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"anykey\">\n\t\t\t\t\t\t\t\t\t<div> <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i> </div>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"videoOrGoback\">\n\t\t\t\t<div ui-sref=\"videodemo\" class=\"gohomeTrain\" ng-if=\"language=='english'\"> <i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i> see a video of the game </div>\n\t\t\t\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='english'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> back to main menu </div>\t\n\t\t\t\t<div ui-sref=\"videodemo\" class=\"gohomeTrain\" ng-if=\"language=='french'\"> <i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i> voir une vidéo du jeu </div>\n\t\t\t\t<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='french'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> retour au menu principal</div>\t\n\t\t\t</div>\n\t\t\t<!--<button ui-sref=\"welcome\"> BACK </button>-->\t\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScoresComponent = undefined;
	
	var _scores = __webpack_require__(99);
	
	var _scores2 = _interopRequireDefault(_scores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var ScoresComponent =
	/*@ngInject*/
	exports.ScoresComponent = ['$scope', '$http', '$rootScope', function ScoresComponent($scope, $http, $rootScope) {
	  'ngInject';
	
	  _classCallCheck(this, ScoresComponent);
	
	  $scope.language = $rootScope.language || 'english';
	  var pagesNumber = 0;
	  $scope.divleft = [];
	  $scope.divright = [];
	  $scope.firstPage = true;
	  $scope.lastPage = false;
	  $scope.pageNumber = 1;
	  $http.get('/api/control/scores').then(function (response) {
	    if (response.status === 200) {
	      $scope.currentScores = JSON.parse(response.data);
	
	      $scope.pagesArray = [];
	      for (var i = 0; i < $scope.currentScores.length; i++) {
	        if (i % 10 == 0) {
	          pagesNumber = pagesNumber + 1;
	
	          console.log($scope.currentScores.length);
	          $scope.pagesArray[pagesNumber - 1] = [];
	        }
	        $scope.pagesArray[pagesNumber - 1][i % 10] = $scope.currentScores[i];
	      }
	      console.log($scope.pagesArray.length);
	
	      $scope.divleft.push(false);
	      $scope.divright.push(false);
	
	      for (var i = 1; i < pagesNumber; i++) {
	        $scope.divright.push(true);
	        $scope.divleft.push(false);
	      }
	      $scope.firstPage = true;
	      $scope.lastPage = false;
	    }
	  });
	  this.message = 'Hello';
	  $scope.nextPage = function () {
	    console.log("next page");
	    var pageInd = 0;
	    while ($scope.divleft[pageInd]) {
	      pageInd = pageInd + 1;
	    }
	    if (pageInd + 1 < pagesNumber) {
	      $scope.divleft[pageInd] = true;
	      $scope.divright[pageInd + 1] = false;
	      $scope.pageNumber = $scope.pageNumber + 1;
	    }
	    $scope.firstPage = false;
	    if (pageInd + 2 == pagesNumber) {
	      $scope.lastPage = true;
	    }
	  };
	
	  $scope.previousPage = function () {
	    console.log("previous page");
	    var pageInd = 0;
	    while ($scope.divleft[pageInd]) {
	      pageInd = pageInd + 1;
	    }
	    if (pageInd > 0) {
	      $scope.divright[pageInd] = true;
	      $scope.divleft[pageInd - 1] = false;
	      $scope.pageNumber = $scope.pageNumber - 1;
	    }
	    $scope.lastPage = false;
	    if (pageInd == 1) {
	      $scope.firstPage = true;
	    }
	  };
	}];
	
	exports.default = angular.module('robotfirefighterApp.scores', [uiRouter]).config(_scores2.default).component('scores', {
	  template: __webpack_require__(100),
	  controller: ScoresComponent,
	  controllerAs: 'scoresCtrl'
	}).name;

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('scores', {
	    url: '/scores',
	    template: '<scores></scores>'
	  });
	}];

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"scoresScreen\">\n\t<div class=\"scoresTitle\" ng-if=\"language=='english'\">\n\t\t<i class=\"fa fa-trophy\" aria-hidden=\"true\"></i> Best scores: \n\t</div>\n\t<div class=\"scoresTitle\" ng-if=\"language=='french'\">\n\t\t<i class=\"fa fa-trophy\" aria-hidden=\"true\"></i> Meilleurs scores: \n\t</div>\n\t<div class=\"scoresPages\">\n\t\t<div class=\"bestScores\" ng-repeat=\"(pagekey, value) in pagesArray\" ng-class=\"{divleft: divleft[pagekey], divright: divright[pagekey]}\">\n\t\t\t<div class=\"scoresNames\">\n\t\t\t\t<span ng-if=\"language=='english'\"> NAME </span>\n\t\t\t\t<span ng-if=\"language=='french'\"> NOM </span>\n\t\t\t\t<div ng-repeat=\"(key, value) in pagesArray[pagekey]\">\n\t\t\t\t\t<i class=\"fa fa-fire-extinguisher\" aria-hidden=\"true\"></i> {{value.name}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"scoresValues\">\n\t\t\t\t<span> SCORE </span>\n\t\t\t\t<div ng-repeat=\"(key, value) in pagesArray[pagekey]\">\n\t\t\t\t\t{{value.score}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"scoresDates\">\n\t\t\t\t<span> DATE </span>\n\t\t\t\t<div ng-repeat=\"(key, value) in pagesArray[pagekey]\">\n\t\t\t\t\t{{value.date}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"controlBand\">\n\t\t<div ui-sref=\"welcome\" class=\"scoresGohome\" ng-if=\"language=='english'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> back to main menu \n\t\t</div> \n\t\t<div ui-sref=\"welcome\" class=\"scoresGohome\" ng-if=\"language=='french'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> retour au menu principal\n\t\t</div> \n\t\t<div class=\"nextprev\">\n\t\t\t<div class=\"scoresGohome\"> \n\t\t\t\t<div ng-hide=\"firstPage\" ng-click=\"previousPage()\" ng-if=\"language=='english'\"> \n\t\t\t\t\t<i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> previous page \n\t\t\t\t</div> \n\t\t\t\t<div ng-hide=\"firstPage\" ng-click=\"previousPage()\" ng-if=\"language=='french'\"> \n\t\t\t\t\t<i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> page précédente\n\t\t\t\t</div> \n\t\t\t</div>\n\t\t\t<div class=\"scoresGohome\" > \n\t\t\t\t<div ng-hide=\"lastPage\" ng-click=\"nextPage()\" ng-if=\"language=='english'\"> \t\t\t\t\n\t\t\t\t\t<i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> next page\n\t\t\t\t</div>\n\t\t\t\t<div ng-hide=\"lastPage\" ng-click=\"nextPage()\" ng-if=\"language=='french'\"> \t\t\t\t\n\t\t\t\t\t<i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> page suivante\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"scorespage\" > \n\t\t\t\tpage {{pageNumber}}\n\t\t\t</div>\t\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideodemoComponent = undefined;
	
	var _videodemo = __webpack_require__(102);
	
	var _videodemo2 = _interopRequireDefault(_videodemo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var VideodemoComponent =
	/*@ngInject*/
	exports.VideodemoComponent = ['$scope', '$rootScope', function VideodemoComponent($scope, $rootScope) {
	  'ngInject';
	
	  _classCallCheck(this, VideodemoComponent);
	
	  this.message = 'Hello';
	  $scope.language = $rootScope.language || 'english';
	}];
	
	exports.default = angular.module('robotfirefighterApp.videodemo', [uiRouter]).config(_videodemo2.default).component('videodemo', {
	  template: __webpack_require__(103),
	  controller: VideodemoComponent,
	  controllerAs: 'videodemoCtrl'
	}).name;

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('videodemo', {
	    url: '/videodemo',
	    template: '<videodemo></videodemo>'
	  });
	}];

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"videodemo\">\n<!--\t<iframe width=\"60%\" height=\"70%\" src=\"https://www.youtube.com/embed/3qftdIPUaAE\" frameBorder=\"0\" allowfullscreen></iframe>-->\n\n<iframe width=\"60%\" height=\"70%\" src=\"https://www.youtube.com/embed/3qftdIPUaAE?rel=0&amp;showinfo=1&amp;autoplay=1&amp;cc_load_policy=1&amp;controls=1&amp;mute=1\" frameborder=\"0\" allowfullscreen></iframe>\n<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='english'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> back to main menu </div>\n<div ui-sref=\"welcome\" class=\"gohomeTrain\" ng-if=\"language=='french'\"> <i class=\"fa fa-reply\" aria-hidden=\"true\"></i> retour au menu principal </div>\n\n\n<!--\n<div id=\"muteYouTubeVideoPlayer\"></div>\n\n<script async src=\"https://youtu.be/3qftdIPUaAE\"></script>\n<script>\n function onYouTubeIframeAPIReady() {\n  var player;\n  player = new YT.Player('muteYouTubeVideoPlayer', {\n    videoId: '3qftdIPUaAE', // YouTube Video ID\n    width: 560,               // Player width (in px)\n    height: 316,              // Player height (in px)\n    playerVars: {\n      autoplay: 1,        // Auto-play the video on load\n      controls: 1,        // Show pause/play buttons in player\n      showinfo: 0,        // Hide the video title\n      modestbranding: 1,  // Hide the Youtube Logo\n      loop: 1,            // Run the video in a loop\n      fs: 0,              // Hide the full screen button\n      cc_load_policty: 0, // Hide closed captions\n      iv_load_policy: 3,  // Hide the Video Annotations\n      autohide: 0         // Hide video controls when playing\n    },\n    events: {\n      onReady: function(e) {\n        e.target.mute();\n      }\n    }\n  });\n }\n</script>\n</div>-->\n"

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExperimentComponent = undefined;
	
	var _experiment = __webpack_require__(105);
	
	var _experiment2 = _interopRequireDefault(_experiment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var ExperimentComponent =
	/*@ngInject*/
	exports.ExperimentComponent = ['$http', '$scope', 'hotkeys', '$timeout', '$interval', '$rootScope', function ExperimentComponent($http, $scope, hotkeys, $timeout, $interval, $rootScope) {
	  'ngInject';
	
	  _classCallCheck(this, ExperimentComponent);
	
	  this.message = 'Hello';
	  $scope.language = $rootScope.language || 'english';
	
	  var scale = new Array();
	  var left = new Array();
	  var right = new Array();
	  var def = new Array();
	  var NUM_SCALES = 6;
	
	  if ($rootScope.language == 'english') {
	    scale[0] = "Mental Demand";
	    left[0] = "Low";
	    right[0] = "High";
	    def[0] = "How much mental and perceptual activity was required (e.g. thinking, deciding, calculating, remembering, looking, searching, etc)? Was the task easy or demanding, simple or complex, exacting or forgiving?";
	
	    scale[1] = "Physical Demand";
	    left[1] = "Low";
	    right[1] = "High";
	    def[1] = "How much physical activity was required (e.g. pushing, pulling, turning, controlling, activating, etc)? Was the task easy or demanding, slow or brisk, slack or strenuous, restful or laborious?";
	
	    scale[2] = "Temporal Demand";
	    left[2] = "Low";
	    right[2] = "High";
	    def[2] = "How much time pressure did you feel due to the rate of pace at which the tasks or task elements occurred? Was the pace slow and leisurely or rapid and frantic?";
	
	    scale[3] = "Performance";
	    left[3] = "Good";
	    right[3] = "Poor";
	    def[3] = "How successful do you think you were in accomplishing the goals of the task set by the experimenter (or yourself)? How satisfied were you with your performance in accomplishing these goals?";
	
	    scale[4] = "Effort";
	    left[4] = "Low";
	    right[4] = "High";
	    def[4] = "How hard did you have to work (mentally and physically) to accomplish your level of performance?";
	
	    scale[5] = "Frustration";
	    left[5] = "Low";
	    right[5] = "High";
	    def[5] = "How insecure, discouraged, irritated, stressed and annoyed versus secure, gratified, content, relaxed and complacent did you feel during the task?";
	  } else if ($rootScope.language == 'french') {
	    scale[0] = "Exigence Mentale";
	    left[0] = "Faible";
	    right[0] = "Elevée";
	    def[0] = "Quelle a été l’importance de l’activité mentale et intellectuelle requise (ex. réflexion, décision, calcul, mémorisation, observation, recherche etc.) ? La tâche vous a-t-elle paru simple, nécessitant peu d’attention (faible) ou complexe, nécessitant beaucoup d’attention (élevée) ?";
	
	    scale[1] = "Exigence Physique";
	    left[1] = "Faible";
	    right[1] = "Elevée";
	    def[1] = "Quelle a été l’importance de l’activité physique requise (ex. pousser, porter, tourner, marcher, activer, etc.) ? La tâche vous a-t-elle paru facile, peu fatigante, calme (faible) ou pénible, fatigante, active (élevée) ?";
	
	    scale[2] = "Exigence Temporelle";
	    left[2] = "Faible";
	    right[2] = "Elevée";
	    def[2] = "Quelle a été l’importance de la pression temporelle causée par la rapidité nécessitée pour l'accomplissement de la tâche ? Etait-ce un rythme lent et tranquille (faible) ou rapide et précipité (élevé) ?";
	
	    scale[3] = "Performance";
	    left[3] = "Bonne";
	    right[3] = "Mauvaise";
	    def[3] = "Quelle réussite pensez-vous avoir eu dans l’accomplissement de votre tâche ? Comment pensez-vous avoir atteint les objectifs déterminés par la tâche ? ";
	
	    scale[4] = "Effort";
	    left[4] = "Faible";
	    right[4] = "Elevé";
	    def[4] = "Quel degré d’effort avez-vous dû fournir pour exécuter la tâche demandée, (mentalement et physiquement) ?";
	
	    scale[5] = "Frustration";
	    left[5] = "Faible";
	    right[5] = "Elevée";
	    def[5] = "Pendant l’exécution du travail vous êtes-vous senti satisfait, relaxé, sûr de vous (niveau de frustration faible), ou plutôt découragé, irrité, stressé, sans assurance (niveau de frustration élevé) ?";
	  }
	
	  var pair = new Array();
	  pair[0] = "4 3";
	  pair[1] = "2 5";
	  pair[2] = "2 4";
	  pair[3] = "1 5";
	  pair[4] = "3 5";
	  pair[5] = "1 2";
	  pair[6] = "1 3";
	  pair[7] = "2 0";
	  pair[8] = "5 4";
	  pair[9] = "3 0";
	  pair[10] = "3 2";
	  pair[11] = "0 4";
	  pair[12] = "0 1";
	  pair[13] = "4 1";
	  pair[14] = "5 0";
	
	  var results_rating = new Array();
	  var results_tally = new Array();
	  var results_weight = new Array();
	  var results_overall;
	
	  var pair_num = 0;
	  for (var i = 0; i < NUM_SCALES; i++) {
	    results_tally[i] = 0;
	  }
	  function randOrd() {
	    return Math.round(Math.random()) - 0.5;
	  }
	
	  for (i = 0; i < 100; i++) {
	    pair.sort(randOrd);
	  }
	
	  $scope.scaleClick = function (index, val) {
	    results_rating[index] = val;
	
	    for (i = 5; i <= 100; i += 5) {
	      var top = "t_" + index + "_" + i;
	      var bottom = "b_" + index + "_" + i;
	      document.getElementById(top).bgColor = '#FFFFFF';
	      document.getElementById(bottom).bgColor = '#FFFFFF';
	    }
	
	    var top = "t_" + index + "_" + val;
	    var bottom = "b_" + index + "_" + val;
	    document.getElementById(top).bgColor = '#AAAAAA';
	    document.getElementById(bottom).bgColor = '#AAAAAA';
	  };
	
	  function getScaleHTML(index) {
	    var result = "";
	
	    result += '<table><tr><td>';
	
	    result += '<table class="scale">';
	
	    result += '<tr><td colspan="20" class="heading">' + scale[index] + '</td></tr>';
	
	    result += '<tr>';
	    var num = 1;
	    for (var i = 5; i <= 100; i += 5) {
	      result += '<td id="t_' + index + '_' + i + '"   class="top' + num + '" onMouseUp="scaleClick(' + index + ', ' + i + ');"></td>';
	      num++;
	      if (num > 2) num = 1;
	    }
	    result += '</tr>';
	
	    result += '<tr>';
	    for (var i = 5; i <= 100; i += 5) {
	      result += '<td id="b_' + index + '_' + i + '"   class="bottom" onMouseUp="scaleClick(' + index + ', ' + i + ');"></td>';
	    }
	    result += '</tr>';
	
	    result += '<tr>';
	    result += '<td colspan="10" class="left">' + left[index] + '</td><td colspan="10" class="right">' + right[index] + '</td>';
	    result += '</tr></table></td>';
	
	    result += '<td class="def">';
	    result += def[index];
	    result += '</td></tr></table>';
	
	    return result;
	  }
	
	  function onLoad() {
	    console.log("onload!");
	
	    for (var i = 0; i < NUM_SCALES; i++) {
	      document.getElementById("scale" + i).innerHTML = getScaleHTML(i);
	    }
	  }
	
	  $scope.buttonPart1 = function () {
	    for (var i = 0; i < NUM_SCALES; i++) {
	      if (!results_rating[i]) {
	        alert('A value must be selected for every scale!');
	        return false;
	      }
	    }
	
	    document.getElementById('div_part1').style.display = 'none';
	    document.getElementById('div_part2').style.display = '';
	
	    return true;
	  };
	
	  $scope.buttonPart2 = function () {
	    document.getElementById('div_part2').style.display = 'none';
	    document.getElementById('div_part3').style.display = '';
	
	    setPairLabels();
	    return true;
	  };
	
	  function setPairLabels() {
	    var indexes = new Array();
	    indexes = pair[pair_num].split(" ");
	
	    var pair1 = scale[indexes[0]];
	    var pair2 = scale[indexes[1]];
	
	    document.getElementById('pair1').value = pair1;
	    document.getElementById('pair2').value = pair2;
	
	    document.getElementById('pair1_def').innerHTML = def[indexes[0]];
	    document.getElementById('pair2_def').innerHTML = def[indexes[1]];
	  }
	
	  $scope.buttonPair1 = function () {
	    var indexes = new Array();
	    indexes = pair[pair_num].split(" ");
	    results_tally[indexes[0]]++;
	
	    nextPair();
	    return true;
	  };
	
	  $scope.buttonPair2 = function () {
	    var indexes = new Array();
	    indexes = pair[pair_num].split(" ");
	    results_tally[indexes[1]]++;
	    nextPair();
	    return true;
	  };
	
	  function calcResults() {
	    results_overall = 0.0;
	
	    for (var i = 0; i < NUM_SCALES; i++) {
	      results_weight[i] = results_tally[i] / 15.0;
	      results_overall += results_weight[i] * results_rating[i];
	    }
	  }
	
	  function getResultsHTML() {
	    var result = "";
	
	    result += "<table><tr><td></td><td>Rating</td><td>Tally</td><td>Weight</td></tr>";
	    for (var i = 0; i < NUM_SCALES; i++) {
	      result += "<tr>";
	
	      result += "<td>";
	      result += scale[i];
	      result += "</td>";
	
	      result += "<td>";
	      result += results_rating[i];
	      result += "</td>";
	
	      result += "<td>";
	      result += results_tally[i];
	      result += "</td>";
	
	      result += "<td>";
	      result += results_weight[i];
	      result += "</td>";
	
	      result += "</tr>";
	    }
	
	    result += "</table>";
	    result += "<br/>";
	    result += "Overall = ";
	    result += results_overall;
	    result += "<br/>";
	
	    return result;
	  }
	
	  function nextPair() {
	    pair_num++;
	    if (pair_num >= 15) {
	      document.getElementById('div_part3').style.display = 'none';
	      document.getElementById('div_part4').style.display = '';
	      calcResults();
	      document.getElementById('div_part4').innerHTML = getResultsHTML();
	      var nasaresult = getResultsHTML();
	      $http.post('/api/control/nasatlx', { nasatlx: nasaresult }).then(function (response) {
	        if (response.status === 200) {
	          console.log("nasa sent");
	        }
	      });
	
	      $http.post('/api/control/markers', { marker: 'nasatlxEnd' }).then(function (response) {
	        if (response.status === 200) {
	          console.log("marker 2 nasatlx sent");
	        }
	      });
	      location.href = 'http://192.168.1.2:8080/experiment';
	    } else {
	      setPairLabels();
	    }
	  }
	
	  document.getElementById('crossesDiv').style.display = 'none';
	  document.getElementById('kss').style.display = 'none';
	  document.getElementById('div_part1').style.display = 'none';
	  document.getElementById('div_part2').style.display = 'none';
	  document.getElementById('div_part3').style.display = 'none';
	  document.getElementById('div_part4').style.display = 'none';
	  document.getElementById('choicepage').style.display = '';
	
	  $scope.rest = false;
	  $scope.commencer = function () {
	    $http.post('/api/control/markers', { marker: 'restBegin' }).then(function (response) {
	      if (response.status === 200) {
	        console.log("marker 1 sent");
	      }
	    });
	    document.getElementById('consigne').style.display = 'none';
	    document.getElementById('commencer').style.display = 'none';
	    $scope.rest = true;
	    setTimeout(function () {
	      console.log("2 sec");
	
	      location.href = 'http://192.168.1.2:8080';
	      $http.post('/api/control/markers', { marker: 'restEnd' }).then(function (response) {
	        if (response.status === 200) {
	          console.log("marker 2 sent");
	          $scope.rest = false;
	        }
	      });
	    }, 60000);
	  };
	
	  $scope.fixacross = function () {
	    document.getElementById('crossesDiv').style.display = '';
	    document.getElementById('choicepage').style.display = 'none';
	    document.getElementById('kss').style.display = 'none';
	  };
	
	  $scope.nasatlx = function () {
	    document.getElementById('crossesDiv').style.display = 'none';
	    document.getElementById('choicepage').style.display = 'none';
	    document.getElementById('kss').style.display = 'none';
	    document.getElementById('div_part1').style.display = '';
	    $http.post('/api/control/markers', { marker: 'nasatlxBegin' }).then(function (response) {
	      if (response.status === 200) {
	        console.log("marker 1 nasatlx sent");
	      }
	    });
	  };
	
	  $scope.kss = function () {
	    document.getElementById('crossesDiv').style.display = 'none';
	    document.getElementById('choicepage').style.display = 'none';
	    document.getElementById('kss').style.display = '';
	    $http.post('/api/control/markers', { marker: 'kssBegin' }).then(function (response) {
	      if (response.status === 200) {
	        console.log("marker 1 nasatlx sent");
	      }
	    });
	  };
	
	  $scope.click1 = function () {
	    if (document.getElementById("Response1").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click2 = function () {
	    if (document.getElementById("Response2").checked) {
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click3 = function () {
	    if (document.getElementById("Response3").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click4 = function () {
	    if (document.getElementById("Response4").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click5 = function () {
	    if (document.getElementById("Response5").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click6 = function () {
	    if (document.getElementById("Response6").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click7 = function () {
	    if (document.getElementById("Response7").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click8 = function () {
	    if (document.getElementById("Response8").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response1").checked = false;
	      document.getElementById("Response9").checked = false;
	    }
	  };
	
	  $scope.click9 = function () {
	    if (document.getElementById("Response9").checked) {
	      document.getElementById("Response2").checked = false;
	      document.getElementById("Response3").checked = false;
	      document.getElementById("Response4").checked = false;
	      document.getElementById("Response5").checked = false;
	      document.getElementById("Response6").checked = false;
	      document.getElementById("Response7").checked = false;
	      document.getElementById("Response8").checked = false;
	      document.getElementById("Response1").checked = false;
	    }
	  };
	
	  document.getElementById("Response1").onchange = $scope.click1;
	  document.getElementById("Response2").onchange = $scope.click2;
	  document.getElementById("Response3").onchange = $scope.click3;
	  document.getElementById("Response4").onchange = $scope.click4;
	  document.getElementById("Response5").onchange = $scope.click5;
	  document.getElementById("Response6").onchange = $scope.click6;
	  document.getElementById("Response7").onchange = $scope.click7;
	  document.getElementById("Response8").onchange = $scope.click8;
	  document.getElementById("Response9").onchange = $scope.click9;
	
	  $scope.saveKss = function () {
	    if (document.getElementById("Response1").checked == false && document.getElementById("Response2").checked == false && document.getElementById("Response3").checked == false && document.getElementById("Response4").checked == false && document.getElementById("Response5").checked == false && document.getElementById("Response6").checked == false && document.getElementById("Response7").checked == false && document.getElementById("Response8").checked == false && document.getElementById("Response9").checked == false) {
	      alert('A box must be checked!');
	    } else {
	      var answer = 0;
	      if (document.getElementById("Response1").checked) {
	        answer = 1;
	      }
	      if (document.getElementById("Response2").checked) {
	        answer = 2;
	      }
	      if (document.getElementById("Response3").checked) {
	        answer = 3;
	      }
	      if (document.getElementById("Response4").checked) {
	        answer = 4;
	      }
	      if (document.getElementById("Response5").checked) {
	        answer = 5;
	      }
	      if (document.getElementById("Response6").checked) {
	        answer = 6;
	      }
	      if (document.getElementById("Response7").checked) {
	        answer = 7;
	      }
	      if (document.getElementById("Response8").checked) {
	        answer = 8;
	      }
	      if (document.getElementById("Response9").checked) {
	        answer = 9;
	      }
	      $http.post('/api/control/kss', { kss: answer }).then(function (response) {
	        if (response.status === 200) {
	          console.log("kss sent");
	        }
	        location.href = 'http://192.168.1.2:8080/experiment';
	        $http.post('/api/control/markers', { marker: 'kssEnd' }).then(function (response) {
	          if (response.status === 200) {
	            console.log("marker 2 kss sent");
	          }
	        });
	      });
	    }
	  };
	}];
	
	exports.default = angular.module('robotfirefighterApp.experiment', [uiRouter]).config(_experiment2.default).component('experiment', {
	  template: __webpack_require__(106),
	  controller: ExperimentComponent,
	  controllerAs: 'experimentCtrl'
	}).name;

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('experiment', {
	    url: '/experiment',
	    template: '<experiment></experiment>'
	  });
	}];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Montserrat\" rel=\"stylesheet\"> \n<div class=\"experiment\">\n\n\t<body onload=\"onLoad();\">\n\n\n\n\n<div id=\"choicepage\" class=\"threeCrossesPage\"> \n\t<div ng-if=\"language=='english'\" id=\"consigne\" class=\"texte\"> \n\t\tThank you very much for contributing to\tour experiment.\t\n\t</div>\n\t<div ng-if=\"language=='french'\" id=\"consigne\" class=\"texte\"> \n\t\tMerci beaucoup de participer à notre expérience.\t\n\t</div>\n\t<div class=\"choix\">\n\t\t<div ng-if=\"language=='english'\" class=\"restornasa\" ng-click=\"fixacross()\"> REST </div>\n\t\t<div ng-if=\"language=='english'\" class=\"restornasa\" ng-click=\"nasatlx()\"> WORKLOAD </div>\n\t\t<div ng-if=\"language=='english'\" class=\"restornasa\" ng-click=\"kss()\"> SLEEPINESS </div>\n\t\t<div ng-if=\"language=='french'\" class=\"restornasa\" ng-click=\"fixacross()\"> REPOS </div>\n\t\t<div ng-if=\"language=='french'\" class=\"restornasa\" ng-click=\"nasatlx()\"> CHARGE MENTALE </div>\n\t\t<div ng-if=\"language=='french'\" class=\"restornasa\" ng-click=\"kss()\"> FATIGUE </div>\n\t</div>\n\t<div class=\"etcalib\" ui-sref=\"etcalib\">  <i class=\"fa fa-eye\" aria-hidden=\"true\"></i> </div>\n</div>\n\n<div id=\"kss\" class=\"apart\" style=\"display:none\"> \n\t<div class=\"kssquiz\">\n\t\t<div ng-if=\"language=='english'\" class=\"texte\"> \n\t\t\tPlease indicate your state of drowsiness at this time \n\t\t\tby checking the box near the number corresponding to your condition. \n\t\t\tYou can also use intermediate conditions.\n\t\t</div>\n\t\t<div ng-if=\"language=='french'\" class=\"texte\"> \n\t\t\tVeuillez indiquer votre état de somnolence à ce moment précis, en entourant le chiffre\n\t\t\tcorrespondant à votre état. Vous pouvez aussi utiliser les états intermédiaires.\n\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response1\">1</label>\n\t\t\t<input type=\"checkbox\" id=\"Response1\" />\n\t\t\t<label ng-if=\"language=='english'\" class=\"description\" for=\"Response1\">Very awake</label>\n\t\t\t<label ng-if=\"language=='french'\" class=\"description\" for=\"Response1\">Très éveillé</label>\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response2\">2</label>\n\t\t\t<input type=\"checkbox\" id=\"Response2\" />\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response3\">3</label>\n\t\t\t<input type=\"checkbox\" id=\"Response3\" />\n\t\t\t<label ng-if=\"language=='english'\" class=\"description\" for=\"Response3\">Awakened - normal level</label>\n\t\t\t<label ng-if=\"language=='french'\" class=\"description\" for=\"Response3\">Eveillé - niveau normal</label>\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response4\">4</label>\n\t\t\t<input type=\"checkbox\" id=\"Response4\" />\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response5\">5</label>\n\t\t\t<input type=\"checkbox\" id=\"Response5\" />\n\t\t\t<label ng-if=\"language=='english'\" class=\"description\" for=\"Response5\">Neither awake nor drowsy</label>\n\t\t\t<label ng-if=\"language=='french'\" class=\"description\" for=\"Response5\">Ni éveillé ni somnolent</label>\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response6\">6</label>\n\t\t\t<input type=\"checkbox\" id=\"Response6\" />\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response7\">7</label>\n\t\t\t<input type=\"checkbox\" id=\"Response7\" />\n\t\t\t<label ng-if=\"language=='english'\" class=\"description\" for=\"Response7\">Sleepy, but without effort to stay awake</label>\n\t\t\t<label ng-if=\"language=='french'\" class=\"description\" for=\"Response7\">Somnolent, mais sans effort pour rester éveillé</label>\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response8\">8</label>\n\t\t\t<input type=\"checkbox\" id=\"Response8\" />\n\t\t</div>\n\t\t<div>\n\t\t\t<label class=\"number\" for=\"Response9\">9</label>\n\t\t\t<input type=\"checkbox\" id=\"Response9\" />\n\t\t\t<label ng-if=\"language=='english'\" class=\"description\" for=\"Response9\">Very sleepy with great effort to stay awake, struggling against sleep</label>\n\t\t\t<label ng-if=\"language=='french'\" class=\"description\" for=\"Response9\">Très somnolent avec de grands efforts pour rester éveillé, luttant contre le sommeil</label>\n\t\t</div>\n\t\t<input ng-if=\"language=='english'\" class=\"next\" value=\"Submit\" type=\"button\" ng-click=\"saveKss()\">\n\t\t<input ng-if=\"language=='french'\" class=\"next\" value=\"Soumettre\" type=\"button\" ng-click=\"saveKss()\">\n\t</div>\n</div>\n\n\n<div id=\"crossesDiv\" class=\"threeCrossesPage\" style=\"display:none\"> \n\t<div ng-if=\"language=='english'\" id=\"consigne\" class=\"texte\" ng-if=\"!rest\"> \n\t\tPlease, try to fix the crosses below during one minute and think of nothing. \t\n\t</div>\n\t<div ng-if=\"language=='french'\" id=\"consigne\" class=\"texte\" ng-if=\"!rest\"> \n\t\tS'il vous pla&icirc;t, essayez de regarder les croix ci-dessous pendant une minute en ne pensant &agrave; rien. \t\n\t</div>\n\t<div class=\"threeCrosses\"> </div>\n\t<input ng-if=\"!rest && language=='english'\" class=\"next\" id=\"commencer\" value=\"Start\" ng-click=\"commencer()\" type=\"button\">\n\t<input ng-if=\"!rest && language=='french'\" class=\"next\" id=\"commencer\" value=\"Commencer\" ng-click=\"commencer()\" type=\"button\">\n</div>\n\n\n\n\n\n\n\n\n\n<!-- \nTODO: un bouton 'commencer', avec 'regardez la croix et ne pensez à rien' qui disparaissent lorsqu'on clique sur commencer  \n\t+ envoie un trigger 'debut cross rest'\n\tla page du jeu apparait au bout d'une minute, avec un trigger 'fin cross rest'\n\ttrigger envoyé lorsqu'il clique sur 'jouer'\n\t+ apres la page de game over, comment arriver sur NASA-TLX?? (+envoyer trigger 'debut naza tlx')\n\t+ les résultats du NASATLX doit etre sauvés à l'aide d'un bouton 'terminer' à la fin du questionnaire\n\t+ le bouton terminer amene à une page proposant du repos, et un bouton 'reprendre' pour recommencer\n\t+ une variable global en js doit permettre de compter le nombre de sessions faites, et de remercier le volontaire à la fin des 4 sessions\n\t+ (merci + kss)\n\nTitre \tDescripteurs \tDescriptions\nExigence Mentale \tDe Faible à Elevée \tQuelle a été l’importance de l’activité mentale et intellectuelle requise (ex. réflexion, décision, calcul, mémorisation, observation, recherche etc.) ? La tâche vous a-t-elle paru simple, nécessitant peu d’attention (faible) ou complexe, nécessitant beaucoup d’attention (élevée) ?\nExigence Physique \tDe Faible à Elevée \tQuelle a été l’importance de l’activité physique requise (ex. pousser, porter, tourner, marcher, activer, etc.) ? La tâche vous a-t-elle paru facile, peu fatigante, calme (faible) ou pénible, fatigante, active (élevée) ?\nExigence Temporelle \tDe Faible à Elevée \tQuelle a été l’importance de la pression temporelle causée par la rapidité nécessitée pour l’accomplissement de la tâche ? Etait-ce un rythme lent et tranquille (faible) ou rapide et précipité (élevé) ?\nPerformance \tDe Bonne à Mauvaise \tQuelle réussite pensez-vous avoir eu dans l’accomplissement de votre tâche ? Comment pensez-vous avoir atteint les objectifs déterminés par la tâche ?\nEffort \tDe Faible à Elevé \tQuel degré d’effort avez-vous dû fournir pour exécuter la tâche demandée, (mentalement et physiquement) ?\nFrustration \tDe Faible à Elevé \tPendant l’exécution du travail vous êtes-vous senti satisfait, relaxé, sûr de vous (niveau de frustration faible), ou plutôt découragé, irrité, stressé, sans assurance (niveau de frustration élevé) ?\n\n\n-->\n\n<div class=\"apart\" id=\"div_part1\"  style=\"display:none\">\n  <div class=\"inapart\">\n  <span  ng-if=\"language=='english'\"> Task Questionnaire - Part 1 </span>\n  <span  ng-if=\"language=='french'\"> Questionnaire sur la tâche - Partie 1 </span> <br>\n  <br>\n  <span ng-if=\"language=='english'\"> Click on each scale at the point that best indicates your experience of the task </span>\n  <span ng-if=\"language=='french'\"> Cliquez sur chaque échelle à l'endroit qui indique le mieux votre expérience sur la tâche. </span> <br>\n  <br>\n\n  <div id=\"scale0\"><table><tbody><tr><td><table class=\"scale\"><tbody><tr><td colspan=\"20\" class=\"heading\">\n<span  ng-if=\"language=='english'\"> Mental Demand </span>\n<span  ng-if=\"language=='french'\"> Exigence Mentale </span>\n</td></tr><tr><td id=\"t_0_5\" class=\"top1\" ng-click=\"scaleClick(0, 5);\"></td><td id=\"t_0_10\" class=\"top2\" ng-click=\"scaleClick(0, 10);\"></td><td id=\"t_0_15\" class=\"top1\" ng-click=\"scaleClick(0, 15);\"></td><td id=\"t_0_20\" class=\"top2\" ng-click=\"scaleClick(0, 20);\"></td><td id=\"t_0_25\" class=\"top1\" ng-click=\"scaleClick(0, 25);\"></td><td id=\"t_0_30\" class=\"top2\" ng-click=\"scaleClick(0, 30);\"></td><td id=\"t_0_35\" class=\"top1\" ng-click=\"scaleClick(0, 35);\"></td><td id=\"t_0_40\" class=\"top2\" ng-click=\"scaleClick(0, 40);\"></td><td id=\"t_0_45\" class=\"top1\" ng-click=\"scaleClick(0, 45);\"></td><td id=\"t_0_50\" class=\"top2\" ng-click=\"scaleClick(0, 50);\"></td><td id=\"t_0_55\" class=\"top1\" ng-click=\"scaleClick(0, 55);\"></td><td id=\"t_0_60\" class=\"top2\" ng-click=\"scaleClick(0, 60);\"></td><td id=\"t_0_65\" class=\"top1\" ng-click=\"scaleClick(0, 65);\"></td><td id=\"t_0_70\" class=\"top2\" ng-click=\"scaleClick(0, 70);\"></td><td id=\"t_0_75\" class=\"top1\" ng-click=\"scaleClick(0, 75);\"></td><td id=\"t_0_80\" class=\"top2\" ng-click=\"scaleClick(0, 80);\"></td><td id=\"t_0_85\" class=\"top1\" ng-click=\"scaleClick(0, 85);\"></td><td id=\"t_0_90\" class=\"top2\" ng-click=\"scaleClick(0, 90);\"></td><td id=\"t_0_95\" class=\"top1\" ng-click=\"scaleClick(0, 95);\"></td><td id=\"t_0_100\" class=\"top2\" ng-click=\"scaleClick(0, 100);\"></td></tr><tr><td id=\"b_0_5\" class=\"bottom\" ng-click=\"scaleClick(0, 5);\"></td><td id=\"b_0_10\" class=\"bottom\" ng-click=\"scaleClick(0, 10);\"></td><td id=\"b_0_15\" class=\"bottom\" ng-click=\"scaleClick(0, 15);\"></td><td id=\"b_0_20\" class=\"bottom\" ng-click=\"scaleClick(0, 20);\"></td><td id=\"b_0_25\" class=\"bottom\" ng-click=\"scaleClick(0, 25);\"></td><td id=\"b_0_30\" class=\"bottom\" ng-click=\"scaleClick(0, 30);\"></td><td id=\"b_0_35\" class=\"bottom\" ng-click=\"scaleClick(0, 35);\"></td><td id=\"b_0_40\" class=\"bottom\" ng-click=\"scaleClick(0, 40);\"></td><td id=\"b_0_45\" class=\"bottom\" ng-click=\"scaleClick(0, 45);\"></td><td id=\"b_0_50\" class=\"bottom\" ng-click=\"scaleClick(0, 50);\"></td><td id=\"b_0_55\" class=\"bottom\" ng-click=\"scaleClick(0, 55);\"></td><td id=\"b_0_60\" class=\"bottom\" ng-click=\"scaleClick(0, 60);\"></td><td id=\"b_0_65\" class=\"bottom\" ng-click=\"scaleClick(0, 65);\"></td><td id=\"b_0_70\" class=\"bottom\" ng-click=\"scaleClick(0, 70);\"></td><td id=\"b_0_75\" class=\"bottom\" ng-click=\"scaleClick(0, 75);\"></td><td id=\"b_0_80\" class=\"bottom\" ng-click=\"scaleClick(0, 80);\"></td><td id=\"b_0_85\" class=\"bottom\" ng-click=\"scaleClick(0, 85);\"></td><td id=\"b_0_90\" class=\"bottom\" ng-click=\"scaleClick(0, 90);\"></td><td id=\"b_0_95\" class=\"bottom\" ng-click=\"scaleClick(0, 95);\"></td><td id=\"b_0_100\" class=\"bottom\" ng-click=\"scaleClick(0, 100);\"></td></tr><tr><td colspan=\"10\">\n<span  ng-if=\"language=='english'\"> Low </span>\n<span ng-if=\"language=='french'\"> Faible </span>\n</td><td colspan=\"10\"  class=\"totheright\">\n<span  ng-if=\"language=='english'\"> High </span>\n<span ng-if=\"language=='french'\"> Elevée </span>\n</td></tr></tbody></table></td><td class=\"def\">\n<span ng-if=\"language=='english'\"> How much mental and perceptual activity was required (e.g. thinking, \ndeciding, calculating, remembering, looking, searching, etc)? Was the \ntask easy or demanding, simple or complex, exacting or forgiving? </span>\n<span ng-if=\"language=='french'\"> Quelle a été l’importance de l’activité mentale et intellectuelle requise \n(ex. réflexion, décision, calcul, mémorisation, observation, recherche etc.) ? \nLa tâche vous a-t-elle paru simple, nécessitant peu d’attention (faible) ou complexe, nécessitant beaucoup d’attention (élevée) ? </span>\n</td></tr></tbody></table></div>\n  <div id=\"scale1\"><table><tbody><tr><td><table class=\"scale\"><tbody><tr><td colspan=\"20\" class=\"heading\">\n<span ng-if=\"language=='english'\"> Physical Demand </span>\n<span ng-if=\"language=='french'\"> Exigence Physique </span>\n</td></tr><tr><td id=\"t_1_5\" class=\"top1\" ng-click=\"scaleClick(1, 5);\"></td><td id=\"t_1_10\" class=\"top2\" ng-click=\"scaleClick(1, 10);\"></td><td id=\"t_1_15\" class=\"top1\" ng-click=\"scaleClick(1, 15);\"></td><td id=\"t_1_20\" class=\"top2\" ng-click=\"scaleClick(1, 20);\"></td><td id=\"t_1_25\" class=\"top1\" ng-click=\"scaleClick(1, 25);\"></td><td id=\"t_1_30\" class=\"top2\" ng-click=\"scaleClick(1, 30);\"></td><td id=\"t_1_35\" class=\"top1\" ng-click=\"scaleClick(1, 35);\"></td><td id=\"t_1_40\" class=\"top2\" ng-click=\"scaleClick(1, 40);\"></td><td id=\"t_1_45\" class=\"top1\" ng-click=\"scaleClick(1, 45);\"></td><td id=\"t_1_50\" class=\"top2\" ng-click=\"scaleClick(1, 50);\"></td><td id=\"t_1_55\" class=\"top1\" ng-click=\"scaleClick(1, 55);\"></td><td id=\"t_1_60\" class=\"top2\" ng-click=\"scaleClick(1, 60);\"></td><td id=\"t_1_65\" class=\"top1\" ng-click=\"scaleClick(1, 65);\"></td><td id=\"t_1_70\" class=\"top2\" ng-click=\"scaleClick(1, 70);\"></td><td id=\"t_1_75\" class=\"top1\" ng-click=\"scaleClick(1, 75);\"></td><td id=\"t_1_80\" class=\"top2\" ng-click=\"scaleClick(1, 80);\"></td><td id=\"t_1_85\" class=\"top1\" ng-click=\"scaleClick(1, 85);\"></td><td id=\"t_1_90\" class=\"top2\" ng-click=\"scaleClick(1, 90);\"></td><td id=\"t_1_95\" class=\"top1\" ng-click=\"scaleClick(1, 95);\"></td><td id=\"t_1_100\" class=\"top2\" ng-click=\"scaleClick(1, 100);\"></td></tr><tr><td id=\"b_1_5\" class=\"bottom\" ng-click=\"scaleClick(1, 5);\"></td><td id=\"b_1_10\" class=\"bottom\" ng-click=\"scaleClick(1, 10);\"></td><td id=\"b_1_15\" class=\"bottom\" ng-click=\"scaleClick(1, 15);\"></td><td id=\"b_1_20\" class=\"bottom\" ng-click=\"scaleClick(1, 20);\"></td><td id=\"b_1_25\" class=\"bottom\" ng-click=\"scaleClick(1, 25);\"></td><td id=\"b_1_30\" class=\"bottom\" ng-click=\"scaleClick(1, 30);\"></td><td id=\"b_1_35\" class=\"bottom\" ng-click=\"scaleClick(1, 35);\"></td><td id=\"b_1_40\" class=\"bottom\" ng-click=\"scaleClick(1, 40);\"></td><td id=\"b_1_45\" class=\"bottom\" ng-click=\"scaleClick(1, 45);\"></td><td id=\"b_1_50\" class=\"bottom\" ng-click=\"scaleClick(1, 50);\"></td><td id=\"b_1_55\" class=\"bottom\" ng-click=\"scaleClick(1, 55);\"></td><td id=\"b_1_60\" class=\"bottom\" ng-click=\"scaleClick(1, 60);\"></td><td id=\"b_1_65\" class=\"bottom\" ng-click=\"scaleClick(1, 65);\"></td><td id=\"b_1_70\" class=\"bottom\" ng-click=\"scaleClick(1, 70);\"></td><td id=\"b_1_75\" class=\"bottom\" ng-click=\"scaleClick(1, 75);\"></td><td id=\"b_1_80\" class=\"bottom\" ng-click=\"scaleClick(1, 80);\"></td><td id=\"b_1_85\" class=\"bottom\" ng-click=\"scaleClick(1, 85);\"></td><td id=\"b_1_90\" class=\"bottom\" ng-click=\"scaleClick(1, 90);\"></td><td id=\"b_1_95\" class=\"bottom\" ng-click=\"scaleClick(1, 95);\"></td><td id=\"b_1_100\" class=\"bottom\" ng-click=\"scaleClick(1, 100);\"></td></tr><tr><td colspan=\"10\" >\n<span ng-if=\"language=='english'\"> Low </span>\n<span ng-if=\"language=='french'\"> Faible </span>\n</td><td colspan=\"10\"  class=\"totheright\">\n<span ng-if=\"language=='english'\">High</span>\n<span ng-if=\"language=='french'\"> Elevée </span>\n</td></tr></tbody></table></td><td class=\"def\">\n<span ng-if=\"language=='english'\"> How much physical activity was required (e.g. pushing, pulling, turning, \ncontrolling, activating, etc)? Was the task easy or demanding, slow or \nbrisk, slack or strenuous, restful or laborious? </span>\n<span ng-if=\"language=='french'\"> Quelle a été l’importance de l’activité physique requise \n(ex. pousser, porter, tourner, marcher, activer, etc.) ? \nLa tâche vous a-t-elle paru facile, peu fatigante, calme (faible) ou pénible, fatigante, active (élevée) ?\n </span>\n</td></tr></tbody></table></div>\n  <div id=\"scale2\"><table><tbody><tr><td><table class=\"scale\"><tbody><tr><td colspan=\"20\" class=\"heading\">\n<span ng-if=\"language=='english'\"> Temporal Demand </span>\n<span ng-if=\"language=='french'\"> Exigence Temporelle </span>\n</td></tr><tr><td id=\"t_2_5\" class=\"top1\" ng-click=\"scaleClick(2, 5);\"></td><td id=\"t_2_10\" class=\"top2\" ng-click=\"scaleClick(2, 10);\"></td><td id=\"t_2_15\" class=\"top1\" ng-click=\"scaleClick(2, 15);\"></td><td id=\"t_2_20\" class=\"top2\" ng-click=\"scaleClick(2, 20);\"></td><td id=\"t_2_25\" class=\"top1\" ng-click=\"scaleClick(2, 25);\"></td><td id=\"t_2_30\" class=\"top2\" ng-click=\"scaleClick(2, 30);\"></td><td id=\"t_2_35\" class=\"top1\" ng-click=\"scaleClick(2, 35);\"></td><td id=\"t_2_40\" class=\"top2\" ng-click=\"scaleClick(2, 40);\"></td><td id=\"t_2_45\" class=\"top1\" ng-click=\"scaleClick(2, 45);\"></td><td id=\"t_2_50\" class=\"top2\" ng-click=\"scaleClick(2, 50);\"></td><td id=\"t_2_55\" class=\"top1\" ng-click=\"scaleClick(2, 55);\"></td><td id=\"t_2_60\" class=\"top2\" ng-click=\"scaleClick(2, 60);\"></td><td id=\"t_2_65\" class=\"top1\" ng-click=\"scaleClick(2, 65);\"></td><td id=\"t_2_70\" class=\"top2\" ng-click=\"scaleClick(2, 70);\"></td><td id=\"t_2_75\" class=\"top1\" ng-click=\"scaleClick(2, 75);\"></td><td id=\"t_2_80\" class=\"top2\" ng-click=\"scaleClick(2, 80);\"></td><td id=\"t_2_85\" class=\"top1\" ng-click=\"scaleClick(2, 85);\"></td><td id=\"t_2_90\" class=\"top2\" ng-click=\"scaleClick(2, 90);\"></td><td id=\"t_2_95\" class=\"top1\" ng-click=\"scaleClick(2, 95);\"></td><td id=\"t_2_100\" class=\"top2\" ng-click=\"scaleClick(2, 100);\"></td></tr><tr><td id=\"b_2_5\" class=\"bottom\" ng-click=\"scaleClick(2, 5);\"></td><td id=\"b_2_10\" class=\"bottom\" ng-click=\"scaleClick(2, 10);\"></td><td id=\"b_2_15\" class=\"bottom\" ng-click=\"scaleClick(2, 15);\"></td><td id=\"b_2_20\" class=\"bottom\" ng-click=\"scaleClick(2, 20);\"></td><td id=\"b_2_25\" class=\"bottom\" ng-click=\"scaleClick(2, 25);\"></td><td id=\"b_2_30\" class=\"bottom\" ng-click=\"scaleClick(2, 30);\"></td><td id=\"b_2_35\" class=\"bottom\" ng-click=\"scaleClick(2, 35);\"></td><td id=\"b_2_40\" class=\"bottom\" ng-click=\"scaleClick(2, 40);\"></td><td id=\"b_2_45\" class=\"bottom\" ng-click=\"scaleClick(2, 45);\"></td><td id=\"b_2_50\" class=\"bottom\" ng-click=\"scaleClick(2, 50);\"></td><td id=\"b_2_55\" class=\"bottom\" ng-click=\"scaleClick(2, 55);\"></td><td id=\"b_2_60\" class=\"bottom\" ng-click=\"scaleClick(2, 60);\"></td><td id=\"b_2_65\" class=\"bottom\" ng-click=\"scaleClick(2, 65);\"></td><td id=\"b_2_70\" class=\"bottom\" ng-click=\"scaleClick(2, 70);\"></td><td id=\"b_2_75\" class=\"bottom\" ng-click=\"scaleClick(2, 75);\"></td><td id=\"b_2_80\" class=\"bottom\" ng-click=\"scaleClick(2, 80);\"></td><td id=\"b_2_85\" class=\"bottom\" ng-click=\"scaleClick(2, 85);\"></td><td id=\"b_2_90\" class=\"bottom\" ng-click=\"scaleClick(2, 90);\"></td><td id=\"b_2_95\" class=\"bottom\" ng-click=\"scaleClick(2, 95);\"></td><td id=\"b_2_100\" class=\"bottom\" ng-click=\"scaleClick(2, 100);\"></td></tr><tr><td colspan=\"10\">\n<span ng-if=\"language=='english'\"> Low </span> \n<span ng-if=\"language=='french'\"> Faible </span>\n</td><td colspan=\"10\"  class=\"totheright\">\n<span ng-if=\"language=='english'\"> High </span> \n<span ng-if=\"language=='french'\"> Elevée </span>\n</td></tr></tbody></table></td><td class=\"def\">\n<span ng-if=\"language=='english'\"> How much time pressure did you feel due to the rate of pace at which the \ntasks or task elements occurred? Was the pace slow and leisurely or \nrapid and frantic? </span>\n<span ng-if=\"language=='french'\"> Quelle a été l’importance de la pression temporelle causée par la rapidité nécessitée \npour l'accomplissement de la tâche ? Etait-ce un rythme lent et tranquille (faible) ou rapide et précipité (élevé) ? </span>\n</td></tr></tbody></table></div>\n  <div id=\"scale3\"><table><tbody><tr><td><table class=\"scale\"><tbody><tr><td colspan=\"20\" class=\"heading\">\n<span> Performance </span>\n</td></tr><tr><td id=\"t_3_5\" class=\"top1\" ng-click=\"scaleClick(3, 5);\"></td><td id=\"t_3_10\" class=\"top2\" ng-click=\"scaleClick(3, 10);\"></td><td id=\"t_3_15\" class=\"top1\" ng-click=\"scaleClick(3, 15);\"></td><td id=\"t_3_20\" class=\"top2\" ng-click=\"scaleClick(3, 20);\"></td><td id=\"t_3_25\" class=\"top1\" ng-click=\"scaleClick(3, 25);\"></td><td id=\"t_3_30\" class=\"top2\" ng-click=\"scaleClick(3, 30);\"></td><td id=\"t_3_35\" class=\"top1\" ng-click=\"scaleClick(3, 35);\"></td><td id=\"t_3_40\" class=\"top2\" ng-click=\"scaleClick(3, 40);\"></td><td id=\"t_3_45\" class=\"top1\" ng-click=\"scaleClick(3, 45);\"></td><td id=\"t_3_50\" class=\"top2\" ng-click=\"scaleClick(3, 50);\"></td><td id=\"t_3_55\" class=\"top1\" ng-click=\"scaleClick(3, 55);\"></td><td id=\"t_3_60\" class=\"top2\" ng-click=\"scaleClick(3, 60);\"></td><td id=\"t_3_65\" class=\"top1\" ng-click=\"scaleClick(3, 65);\"></td><td id=\"t_3_70\" class=\"top2\" ng-click=\"scaleClick(3, 70);\"></td><td id=\"t_3_75\" class=\"top1\" ng-click=\"scaleClick(3, 75);\"></td><td id=\"t_3_80\" class=\"top2\" ng-click=\"scaleClick(3, 80);\"></td><td id=\"t_3_85\" class=\"top1\" ng-click=\"scaleClick(3, 85);\"></td><td id=\"t_3_90\" class=\"top2\" ng-click=\"scaleClick(3, 90);\"></td><td id=\"t_3_95\" class=\"top1\" ng-click=\"scaleClick(3, 95);\"></td><td id=\"t_3_100\" class=\"top2\" ng-click=\"scaleClick(3, 100);\"></td></tr><tr><td id=\"b_3_5\" class=\"bottom\" ng-click=\"scaleClick(3, 5);\"></td><td id=\"b_3_10\" class=\"bottom\" ng-click=\"scaleClick(3, 10);\"></td><td id=\"b_3_15\" class=\"bottom\" ng-click=\"scaleClick(3, 15);\"></td><td id=\"b_3_20\" class=\"bottom\" ng-click=\"scaleClick(3, 20);\"></td><td id=\"b_3_25\" class=\"bottom\" ng-click=\"scaleClick(3, 25);\"></td><td id=\"b_3_30\" class=\"bottom\" ng-click=\"scaleClick(3, 30);\"></td><td id=\"b_3_35\" class=\"bottom\" ng-click=\"scaleClick(3, 35);\"></td><td id=\"b_3_40\" class=\"bottom\" ng-click=\"scaleClick(3, 40);\"></td><td id=\"b_3_45\" class=\"bottom\" ng-click=\"scaleClick(3, 45);\"></td><td id=\"b_3_50\" class=\"bottom\" ng-click=\"scaleClick(3, 50);\"></td><td id=\"b_3_55\" class=\"bottom\" ng-click=\"scaleClick(3, 55);\"></td><td id=\"b_3_60\" class=\"bottom\" ng-click=\"scaleClick(3, 60);\"></td><td id=\"b_3_65\" class=\"bottom\" ng-click=\"scaleClick(3, 65);\"></td><td id=\"b_3_70\" class=\"bottom\" ng-click=\"scaleClick(3, 70);\"></td><td id=\"b_3_75\" class=\"bottom\" ng-click=\"scaleClick(3, 75);\"></td><td id=\"b_3_80\" class=\"bottom\" ng-click=\"scaleClick(3, 80);\"></td><td id=\"b_3_85\" class=\"bottom\" ng-click=\"scaleClick(3, 85);\"></td><td id=\"b_3_90\" class=\"bottom\" ng-click=\"scaleClick(3, 90);\"></td><td id=\"b_3_95\" class=\"bottom\" ng-click=\"scaleClick(3, 95);\"></td><td id=\"b_3_100\" class=\"bottom\" ng-click=\"scaleClick(3, 100);\"></td></tr><tr><td colspan=\"10\">\n<span ng-if=\"language=='english'\"> Good </span> \n<span ng-if=\"language=='french'\"> Bonne </span>\n</td><td colspan=\"10\"  class=\"totheright\">\n<span ng-if=\"language=='english'\"> Poor </span>\n<span ng-if=\"language=='french'\"> Mauvaise </span>\n</td></tr></tbody></table></td><td class=\"def\">\n<span ng-if=\"language=='english'\"> How successful do you think you were in accomplishing the goals of the task\n set by the experimenter (or yourself)? How satisfied were you with your\n performance in accomplishing these goals? </span>\n<span ng-if=\"language=='french'\"> Quelle réussite pensez-vous avoir eu dans l’accomplissement de votre tâche ? \nComment pensez-vous avoir atteint les objectifs déterminés par la tâche ? </span>\n</td></tr></tbody></table></div>\n  <div id=\"scale4\"><table><tbody><tr><td><table class=\"scale\"><tbody><tr><td colspan=\"20\" class=\"heading\">\n<span> Effort </span>\n</td></tr><tr><td id=\"t_4_5\" class=\"top1\" ng-click=\"scaleClick(4, 5);\"></td><td id=\"t_4_10\" class=\"top2\" ng-click=\"scaleClick(4, 10);\"></td><td id=\"t_4_15\" class=\"top1\" ng-click=\"scaleClick(4, 15);\"></td><td id=\"t_4_20\" class=\"top2\" ng-click=\"scaleClick(4, 20);\"></td><td id=\"t_4_25\" class=\"top1\" ng-click=\"scaleClick(4, 25);\"></td><td id=\"t_4_30\" class=\"top2\" ng-click=\"scaleClick(4, 30);\"></td><td id=\"t_4_35\" class=\"top1\" ng-click=\"scaleClick(4, 35);\"></td><td id=\"t_4_40\" class=\"top2\" ng-click=\"scaleClick(4, 40);\"></td><td id=\"t_4_45\" class=\"top1\" ng-click=\"scaleClick(4, 45);\"></td><td id=\"t_4_50\" class=\"top2\" ng-click=\"scaleClick(4, 50);\"></td><td id=\"t_4_55\" class=\"top1\" ng-click=\"scaleClick(4, 55);\"></td><td id=\"t_4_60\" class=\"top2\" ng-click=\"scaleClick(4, 60);\"></td><td id=\"t_4_65\" class=\"top1\" ng-click=\"scaleClick(4, 65);\"></td><td id=\"t_4_70\" class=\"top2\" ng-click=\"scaleClick(4, 70);\"></td><td id=\"t_4_75\" class=\"top1\" ng-click=\"scaleClick(4, 75);\"></td><td id=\"t_4_80\" class=\"top2\" ng-click=\"scaleClick(4, 80);\"></td><td id=\"t_4_85\" class=\"top1\" ng-click=\"scaleClick(4, 85);\"></td><td id=\"t_4_90\" class=\"top2\" ng-click=\"scaleClick(4, 90);\"></td><td id=\"t_4_95\" class=\"top1\" ng-click=\"scaleClick(4, 95);\"></td><td id=\"t_4_100\" class=\"top2\" ng-click=\"scaleClick(4, 100);\"></td></tr><tr><td id=\"b_4_5\" class=\"bottom\" ng-click=\"scaleClick(4, 5);\"></td><td id=\"b_4_10\" class=\"bottom\" ng-click=\"scaleClick(4, 10);\"></td><td id=\"b_4_15\" class=\"bottom\" ng-click=\"scaleClick(4, 15);\"></td><td id=\"b_4_20\" class=\"bottom\" ng-click=\"scaleClick(4, 20);\"></td><td id=\"b_4_25\" class=\"bottom\" ng-click=\"scaleClick(4, 25);\"></td><td id=\"b_4_30\" class=\"bottom\" ng-click=\"scaleClick(4, 30);\"></td><td id=\"b_4_35\" class=\"bottom\" ng-click=\"scaleClick(4, 35);\"></td><td id=\"b_4_40\" class=\"bottom\" ng-click=\"scaleClick(4, 40);\"></td><td id=\"b_4_45\" class=\"bottom\" ng-click=\"scaleClick(4, 45);\"></td><td id=\"b_4_50\" class=\"bottom\" ng-click=\"scaleClick(4, 50);\"></td><td id=\"b_4_55\" class=\"bottom\" ng-click=\"scaleClick(4, 55);\"></td><td id=\"b_4_60\" class=\"bottom\" ng-click=\"scaleClick(4, 60);\"></td><td id=\"b_4_65\" class=\"bottom\" ng-click=\"scaleClick(4, 65);\"></td><td id=\"b_4_70\" class=\"bottom\" ng-click=\"scaleClick(4, 70);\"></td><td id=\"b_4_75\" class=\"bottom\" ng-click=\"scaleClick(4, 75);\"></td><td id=\"b_4_80\" class=\"bottom\" ng-click=\"scaleClick(4, 80);\"></td><td id=\"b_4_85\" class=\"bottom\" ng-click=\"scaleClick(4, 85);\"></td><td id=\"b_4_90\" class=\"bottom\" ng-click=\"scaleClick(4, 90);\"></td><td id=\"b_4_95\" class=\"bottom\" ng-click=\"scaleClick(4, 95);\"></td><td id=\"b_4_100\" class=\"bottom\" ng-click=\"scaleClick(4, 100);\"></td></tr><tr><td colspan=\"10\" >\n<span ng-if=\"language=='english'\"> Low </span> \n<span ng-if=\"language=='french'\"> Faible </span>\n</td><td colspan=\"10\" class=\"totheright\">\n<span ng-if=\"language=='english'\"> High </span>\n<span ng-if=\"language=='french'\"> Elevé </span>\n</td></tr></tbody></table></td><td class=\"def\">\n<span ng-if=\"language=='english'\"> How hard did you have to work (mentally and physically) to accomplish your level of performance? </span>\n<span ng-if=\"language=='french'\"> Quel degré d’effort avez-vous dû fournir pour exécuter la tâche demandée, (mentalement et physiquement) ? </span>\n</td></tr></tbody></table></div>\n  <div id=\"scale5\">\n\t<table>\n\t\t<tbody>\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<table class=\"scale\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td colspan=\"20\" class=\"heading\"> \n<span> Frustration </span>\n</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td id=\"t_5_5\" class=\"top1\" ng-click=\"scaleClick(5, 5);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_10\" class=\"top2\" ng-click=\"scaleClick(5, 10);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_15\" class=\"top1\" ng-click=\"scaleClick(5, 15);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_20\" class=\"top2\" ng-click=\"scaleClick(5, 20);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_25\" class=\"top1\" ng-click=\"scaleClick(5, 25);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_30\" class=\"top2\" ng-click=\"scaleClick(5, 30);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_35\" class=\"top1\" ng-click=\"scaleClick(5, 35);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_40\" class=\"top2\" ng-click=\"scaleClick(5, 40);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_45\" class=\"top1\" ng-click=\"scaleClick(5, 45);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_50\" class=\"top2\" ng-click=\"scaleClick(5, 50);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_55\" class=\"top1\" ng-click=\"scaleClick(5, 55);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_60\" class=\"top2\" ng-click=\"scaleClick(5, 60);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_65\" class=\"top1\" ng-click=\"scaleClick(5, 65);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_70\" class=\"top2\" ng-click=\"scaleClick(5, 70);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_75\" class=\"top1\" ng-click=\"scaleClick(5, 75);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_80\" class=\"top2\" ng-click=\"scaleClick(5, 80);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_85\" class=\"top1\" ng-click=\"scaleClick(5, 85);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_90\" class=\"top2\" ng-click=\"scaleClick(5, 90);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_95\" class=\"top1\" ng-click=\"scaleClick(5, 95);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"t_5_100\" class=\"top2\" ng-click=\"scaleClick(5, 100);\"></td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td id=\"b_5_5\" class=\"bottom\" ng-click=\"scaleClick(5, 5);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_10\" class=\"bottom\" ng-click=\"scaleClick(5, 10);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_15\" class=\"bottom\" ng-click=\"scaleClick(5, 15);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_20\" class=\"bottom\" ng-click=\"scaleClick(5, 20);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_25\" class=\"bottom\" ng-click=\"scaleClick(5, 25);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_30\" class=\"bottom\" ng-click=\"scaleClick(5, 30);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_35\" class=\"bottom\" ng-click=\"scaleClick(5, 35);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_40\" class=\"bottom\" ng-click=\"scaleClick(5, 40);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_45\" class=\"bottom\" ng-click=\"scaleClick(5, 45);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_50\" class=\"bottom\" ng-click=\"scaleClick(5, 50);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_55\" class=\"bottom\" ng-click=\"scaleClick(5, 55);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_60\" class=\"bottom\" ng-click=\"scaleClick(5, 60);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_65\" class=\"bottom\" ng-click=\"scaleClick(5, 65);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_70\" class=\"bottom\" ng-click=\"scaleClick(5, 70);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_75\" class=\"bottom\" ng-click=\"scaleClick(5, 75);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_80\" class=\"bottom\" ng-click=\"scaleClick(5, 80);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_85\" class=\"bottom\" ng-click=\"scaleClick(5, 85);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_90\" class=\"bottom\" ng-click=\"scaleClick(5, 90);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_95\" class=\"bottom\" ng-click=\"scaleClick(5, 95);\"></td>\n\t\t\t\t\t\t\t\t<td id=\"b_5_100\" class=\"bottom\" ng-click=\"scaleClick(5, 100);\"></td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td colspan=\"10\"> \n<span ng-if=\"language=='english'\"> Low </span>\n<span ng-if=\"language=='french'\"> Faible </span> \n\n</td>\n\t\t\t\t\t\t\t\t<td colspan=\"10\" class=\"totheright\"> \n<span ng-if=\"language=='english'\"> High </span> \n<span ng-if=\"language=='french'\"> Elevée </span>\n\n</td>\n\n<!--\n\t\t\t\t\t\t\t\t<div class=\"lowhigh\">\n\t\t\t\t\t\t\t\t\t<div> Low </div>\n\t\t\t\t\t\t\t\t\t<div> High </div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<td colspan=\"10\" class=\"left\">Low</td>\n\t\t\t\t\t\t\t\t<td colspan=\"10\" class=\"right\">High</td> -->\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</td>\n\t\t\t\t<td class=\"def\">\n<span ng-if=\"language=='english'\"> How insecure, discouraged, irritated, stressed and annoyed versus secure, \ngratified, content, relaxed and complacent did you feel during the task? </span>\n<span ng-if=\"language=='french'\"> Pendant l’exécution du travail vous êtes-vous senti satisfait, \nrelaxé, sûr de vous (niveau de frustration faible), ou plutôt découragé, \nirrité, stressé, sans assurance (niveau de frustration élevé) ?\n </span>\n</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n  </div>\n\n  <br>\n  <input ng-if=\"language=='english'\" class=\"next\" id=\"next\" value=\"Continue &gt;&gt;\" ng-click=\"buttonPart1();\" type=\"button\">\n  <input ng-if=\"language=='french'\" class=\"next\" id=\"next\" value=\"Continuer &gt;&gt;\" ng-click=\"buttonPart1();\" type=\"button\">\n  </div>\n</div>\n\n<div class=\"apart\" id=\"div_part2\" style=\"display:none\">\n  <div class=\"inapart\">\n  <span ng-if=\"language=='english'\"> Task Questionnaire - Part 2 </span>\n  <span ng-if=\"language=='french'\"> Questionnaire sur la tâche - Partie 2 </span> <br>\n  <br>\n  <span ng-if=\"language=='english'\"> One each of the following 15 screens, click on the scale title that represents the\n  more important contributor to workload for the task </span>\n  <span ng-if=\"language=='french'\"> Pour chacuns des 15 prochains écrans, cliquez sur le nom de l'échelle \nqui contribue le plus à la charge mentale pour la tâche. </span> <br>\n  <br>\n  <input  ng-if=\"language=='english'\" class=\"next\" id=\"next\" value=\"Continue &gt;&gt;\" ng-click=\"buttonPart2();\" type=\"button\">\n  <input  ng-if=\"language=='french'\" class=\"next\" id=\"next\" value=\"Continuer &gt;&gt;\" ng-click=\"buttonPart2();\" type=\"button\">\n  </div>\n</div>\n\n<div class=\"apart\" id=\"div_part3\" style=\"display:none\">\n  <div class=\"inapart\">\n  <span ng-if=\"language=='english'\"> Task Questionnaire - Part 2 </span> \n  <span ng-if=\"language=='french'\"> Questionnaire sur la tâche - Partie 2 </span> \n<br>\n  <br>\n\n  <span ng-if=\"language=='english'\">Click on the factor that represents the more important contributor to workload for the task </span>\n  <span ng-if=\"language=='french'\"> Cliquez sur le facteur qui contribue le plus à la charge mentale pour la tâche. </span><br>\n  <br>\n  <table>\n    <tbody><tr>\n      <td><input class=\"pair\" id=\"pair1\" value=\"\" ng-click=\"buttonPair1();\" type=\"button\"> </td>\n      <td class=\"def\"><div id=\"pair1_def\"></div></td>\n    </tr>\n    <tr>\n      <td align=\"center\"> <span  ng-if=\"language=='english'\">or </span> <span  ng-if=\"language=='french'\"> ou </span> </td>\n      <td></td>\n    </tr>\n    <tr>\n      <td><input class=\"pair\" id=\"pair2\" value=\"\" ng-click=\"buttonPair2();\" type=\"button\"></td>\n      <td class=\"def\"><div id=\"pair2_def\"></div></td>\n    </tr>\n  </tbody></table>\n</div>\n</div>\n\n<div class=\"apart\" id=\"div_part4\" style=\"display:none\">\n</div>\n\n\n</div>\n"

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EtcalibComponent = undefined;
	
	var _etcalib = __webpack_require__(108);
	
	var _etcalib2 = _interopRequireDefault(_etcalib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(10);
	
	var EtcalibComponent =
	/*@ngInject*/
	exports.EtcalibComponent = ['$scope', '$http', '$rootScope', '$interval', function EtcalibComponent($scope, $http, $rootScope, $interval) {
	  'ngInject';
	
	  _classCallCheck(this, EtcalibComponent);
	
	  this.$http = $http;
	  var debug = false;
	  this.message = 'Hello';
	
	  var zoneslocations;
	  $scope.zones = [];
	  $scope.zones[0] = { x: '20%', y: '10%' };
	  $scope.zones[1] = { x: '30%', y: '40%' };
	  $http.get('/api/control/zones').then(function (response) {
	    console.log("$http.get");
	    if (response.status === 200) {
	      zoneslocations = JSON.parse(response.data);
	      $scope.zones = zoneslocations;
	      for (var i = 0; i < zoneslocations.length; i++) {
	        var xValz = $scope.realToCssPoseX(parseFloat(zoneslocations[i].x));
	        var yValz = $scope.realToCssPoseY(parseFloat(zoneslocations[i].y));
	        $scope.zones[i].x = xValz;
	        $scope.zones[i].y = yValz;
	        console.log("ZONES:");
	        console.log($scope.zones[i].x);
	        console.log($scope.zones[i].y);
	      }
	    } else {
	      console.log("response status error");
	      console.log(response.status);
	    }
	    console.log("COUCOU");
	    console.log($scope.zones);
	  });
	
	  var treeslocations;
	  $scope.trees = [];
	  $scope.firesloc = [];
	  $scope.opacityfire = [];
	  $http.get('/api/control').then(function (response) {
	    if (response.status === 200) {
	      treeslocations = JSON.parse(response.data);
	      $scope.trees = treeslocations;
	      for (var i = 0; i < treeslocations.length; i++) {
	        var xVal = $scope.realToCssPoseX(parseFloat(treeslocations[i].x));
	        var yVal = $scope.realToCssPoseY(parseFloat(treeslocations[i].y));
	        $scope.trees[i].x = xVal;
	        $scope.trees[i].y = yVal;
	        $scope.firesloc.push({ x: xVal, y: (parseFloat(yVal.slice(0, -1)) - 3.8).toString() + '%' });
	        $scope.opacityfire.push(0);
	        console.log("trees:");
	        console.log($scope.trees[i].x);
	        console.log($scope.trees[i].y);
	      }
	      $scope.opacityfire[3] = 1;
	      $scope.opacityfire[8] = 1;
	      $scope.opacityfire[5] = 1;
	      $scope.opacityfire[1] = 1;
	    }
	  });
	
	  var translationX = 19;
	  var normalizationX = 38;
	  var translationY = 19;
	  var normalizationY = 38;
	  $scope.realToCssPoseX = function (realPose) {
	    return (-5 + (realPose + translationX) * 100.0 / normalizationX).toString() + '%';
	  };
	  $scope.realToCssPoseY = function (realPose) {
	    return (95 - (realPose + translationY) * 100.0 / normalizationY).toString() + '%';
	  };
	
	  $scope.firstPump = 2;
	  $scope.watlevel = 50;
	  $scope.xrobinet = 45;
	  $scope.watlevelContainer = 50;
	  $scope.watlevelContainerMap = 50;
	  $scope.xrobinetwater = 49;
	  $scope.faucetxaxis = 20;
	  $scope.yrobinet = 60;
	  $scope.waterwidth = 0.5;
	  $scope.battlevel = 50;
	  $scope.autonomous = 0;
	  $scope.mercurelevel = "25%";
	  $scope.nbfighted = 5;
	  $scope.remainingtime = 257;
	  $scope.language = $rootScope.language || 'english';
	
	  $scope.propFromLeft = '10%';
	  $scope.propFromTop = '30%';
	
	  $scope.AOI = 0;
	  var AOIInterval = $interval(function () {
	    $http.get('/api/control/AOI').then(function (response) {
	      if (response.status === 200) {
	        console.log("response:");
	        console.log(response.data);
	        $scope.AOI = Number(response.data) + 1;
	        console.log($scope.AOI);
	      }
	    });
	  }, 200);
	  $scope.$on("$destroy", function () {
	    if (AOIInterval) {
	      $interval.cancel(AOIInterval);
	    }
	  });
	}];
	
	exports.default = angular.module('robotfirefighterApp.etcalib', [uiRouter]).config(_etcalib2.default).component('etcalib', {
	  template: __webpack_require__(109),
	  controller: EtcalibComponent,
	  controllerAs: 'etcalibCtrl'
	}).name;

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('etcalib', {
	    url: '/etcalib',
	    template: '<etcalib></etcalib>'
	  });
	}];

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	module.exports = "<div class=\"screen\" ng-class=\"{screenWrench: wrenchMode}\" ng-click=\"otherclick()\">\n\n\t<div class=\"leftPart\">  \n\t\t<div class=\"missionBlock\">\n\t\t\t<div  class=\"maincontainermission\" ng-class=\"{maincontainermissionET: AOI==1}\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-trophy\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gametitle\">\n\t\t\t\t\tFirefighter Human-Robot Team <div class=\"fireicon\"> </div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"infonoff\">\t\n\t\t\t\t\t<div class=\"missioninfo\">\n\t\t\t\t\t\t<div class=\"numbersinfo\"> \n\t\t\t\t\t\t\t<!-- <i class=\"fa fa-star-o\" aria-hidden=\"true\"></i> -->\n\t\t\t\t\t\t\t<i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t{{nbfighted}} \n\t\t\t\t\t\t</div> \n\t\t\t\t\t\t<div  class=\"numbersinfo\"> <i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i>   {{remainingtime}} </div>\n\t\t\t\t\t\t\t<!--<button ng-click=\"killall()\" ui-sref=\"welcome\">Kill all!</button>-->\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"onoff\">\t\t\t\t\t\t\n\t\t\t\t\t\t<i ng-click=\"killall()\" ui-sref=\"welcome\" class=\"fa fa-power-off\" aria-hidden=\"true\"></i>\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"waterBlock\"> \n\t\t\t<div  class=\"maincontainerwater\" ng-class=\"{maincontainerwaterET: AOI==2}\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t            <div class=\"robinetcontainer\">\n\t\t\t\t\t<div class=\"robinet\" ng-style=\"{left: xrobinet+2+'%', bottom: yrobinet/1.8 + 42 +'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction!=0\" ng-class=\"{wheelinverse: direction<0}\"  ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+58+'%', 'animation-duration': animtime + 's'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"wheel\" ng-if=\"direction==0\" ng-style=\"{left: xrobinet+7.9+'%', bottom: yrobinet/1.8+58+'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"string\" ng-style=\"{left: xrobinet+11.5+'%', bottom: yrobinet/1.8+52+'%'}\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"robinetwaterContainer\" ng-style=\"{left: xrobinetwater-0.6+'%', bottom: yrobinet/1.8 + 37 +'%'}\">\n\t\t\t\t\t\t<div class=\"robinetwater\" ng-style=\"{width: waterwidth + 'vw', 'background-size': waterwidth + 'vw 1vw'}\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"montainAxis\"> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"neckcontainer\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"tankcontainer\">\t\n\t\t\t\t\t\t<div class=\"tankcontainerwaterpart\">\n\t\t\t\t\t\t\t<div class=\"tankcontainerwaterviz\">\n\t\t\t\t\t\t\t\t<div class=\"graduations\"> </div>\n\t\t\t\t\t\t\t\t<div class=\"tankcontainerwater\" ng-style=\"{height: watlevelContainer + '%'}\"> \n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n<!-- TODO manage water level w.r.t leaks and pushbutton and tap position\nleaks/wrench/etc in server files-->\n\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t<div class=\"tankcontainerleakspart\">\n\t\t\t\t\t\t\t<!--<div class=\"bigCross\" ng-class=\"{nonvisible: !brokenContainer}\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\" ng-style=\"{'font-size': crossSize + 'vw'}\"></i>\n\t\t\t\t\t\t\t</div>-->\n<!--  -->\n\t\t\t\t\t\t\t<div class=\"wrapLeaks\">\n\t\t\t\t\t\t\t\t<div class=\"leakContainer\" ng-repeat=\"(key, value) in leakPlaces\">\n\t\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[key]}\" ng-style=\"{'transform': 'scale(' + leaksReverse[key] + ', 1)', 'left': leftValues[key] + '%'}\"  ng-click=\"clickLeak(key); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n<!--\t\t\t\t\t\t\t<div class=\"topleaks\">\n\t\t\t\t\t\t\t\t<div class=\"leaks\">\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[0]}\" ng-click=\"clickLeak(0)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[1]}\" ng-click=\"clickLeak(1)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t<div class=\"containertap\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leaks\">\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[2]}\" ng-click=\"clickLeak(2)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"leaktop\" ng-class=\"{nonvisible: noleakat[3]}\" ng-click=\"clickLeak(3)\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"botleaks\">\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[4]}\" ng-click=\"clickLeak(4)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[5]}\" ng-click=\"clickLeak(5)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[6]}\" ng-click=\"clickLeak(6)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"leak\" ng-class=\"{nonvisible: noleakat[7]}\" ng-click=\"clickLeak(7)\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n-->\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"legsContainer\">\n\t\t\t\t\t\t\t<div class=\"legs\">\n\t\t\t\t\t\t\t</div>                           \t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n<!--\n\t\t\t\t\t<div> \n\t\t\t\t\t\t<span> TAP POSITION: {{faucetxaxis}} </span> \n\t\t\t\t\t\t \n\t\t\t\t\t</div>\n-->\n\t\t\t\t\t<div class=\"wmbuttons\">\n\t\t\t\t\t\t<!-- <i class=\"fa fa-mouse-pointer\" aria-hidden=\"true\"></i> -->\n\t\t\t\t\t\t<div class=\"speed\">  \n\t\t\t\t\t\t\t<div class=\"wheelsmall2\"> </div>\n\t\t\t\t\t\t\t<div ng-if=\"language=='english'\"> speed: {{faucetcontrol}} </div>\n\t\t\t\t\t\t\t<div ng-if=\"language=='french'\"> vitesse: {{faucetcontrol}} </div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonWheel\">\n\t\t\t\t\t\t\t<div class=\"buttonChar\">\n\t\t\t\t\t\t\t\t<div class=\"mainbuttonL\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"faucetctrlfctminus(); $event.stopPropagation();\"> \n\t\t\t\t\t\t\t\t\t<div class=\"undo\"> <i class=\"fa fa-undo\" aria-hidden=\"true\"></i></div>\n\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"char\"> s </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t\t<div class=\"mainbuttonR\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"faucetctrlfctplus(); $event.stopPropagation();\"> \n\t\t\t\t\t\t\t\t\t<div class=\"undo\">  <i class=\"fa fa-undo\" aria-hidden=\"true\"></i> </div>\n\t\t\t\t\t\t\t\t\t<div class=\"wheelsmall\"> </div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"char\"> d </div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t<div class=\"pushButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"waterPushButton(); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t<!--<div class=\"pbcircle\">\n\t\t\t\t\t\t\t\t\t<div class=\"pbcirclesmall\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>-->\n\t\t\t\t\t\t\t\t<div class=\"buttonTap\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"char\"> e </div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"buttonletterChar\">\n\t\t\t\t\t\t\t<div class=\"wrenchButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"wrenchOnOff(); $event.stopPropagation();\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"char\"> a </div>\n\t\t\t\t\t\t</div>\n<!--\n\t\t\t\t\t\t<div class=\"newContainerButton\" ng-class=\"{cursorPointer: !wrenchMode}\" ng-click=\"newContainer()\">\n\t\t\t\t\t\t\t<div class=\"containerIcon\">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>-->\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\t\t\t\t\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"rightPart\"> \n\t\t<div class=\"videoBlock\"> \n\t\t\t<div class=\"maincontainercam\" ng-class=\"{maincontainercamET: AOI==3}\">\n\t\t\t\t<div class=\"streamcameraET\">\n\t\t\t\t\t<div class=\"imagecamET\"> </div>\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\t\t\n\t\t</div>\n\t\t<div class=\"infoBlock\"> \n\t\t\t<div class=\"maincontainer\" ng-class=\"{maincontainerET: AOI==4 || AOI==5}\">\n\t\t\t\t<div class=\"iconCircle\">\n\t\t\t\t\t<i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"iconscontents\">\n\t\t\t\t\t<div class=\"linktoicon\" ng-class=\"{linktoiconET: AOI==4}\">\n\t\t\t\t\t\t<i class=\"fa fa-globe\" aria-hidden=\"true\"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"maincontainersec\" ng-class=\"{maincontainersecET: AOI==4}\">\n\t\t\t\t\t\t<div class=\"mapblock\">\n\t\t\t\t\t\t\t<div class=\"map\">\n\t\t\t\t\t\t\t\t<div class=\"point\" ng-style=\"{top: propFromTop, left: propFromLeft, transform: 'rotate('+ rotindeg +'deg)'}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"tree\" ng-repeat=\"(key, value) in trees\" ng-style=\"{top: value.y, left: value.x}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"fire\" ng-repeat=\"(key, value) in firesloc\" ng-style=\"{top: value.y, left: value.x, opacity: opacityfire[key]}\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"loadlocB\" ng-style=\"{top: zones[1].y, left: zones[1].x}\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-bolt\" aria-hidden=\"true\"></i>\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"loadlocW\" ng-style=\"{top: zones[0].y, left: zones[0].x}\">\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-tint\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"waterlevelmap\" ng-style=\"{height: watlevelContainerMap + 'px'}\">\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!--<span> {{nbonfire}} </span>-->\n\t\t\t\t</div>\n\t\t\t\t<div class=\"iconscontents2\">\n\t\t\t\t\t<div class=\"linktoicon\"  ng-class=\"{linktoiconET: AOI==5}\">\n\t\t\t\t\t\t<div class=\"robothead\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"maincontainersec2\"  ng-class=\"{maincontainersecET: AOI==5}\">\n\t\t\t\t\t\t<div class=\"warningsblock\">\n\t\t\t\t\t\t\t<div class=\"robtoppart\">\n\t\t\t\t\t\t\t\t<div class=\"autonomy\">\n\t\t\t\t\t\t\t\t\t<div class=\"brain\" ng-if=\"autonomous\"> <!-- <i class=\"fa fa-signal\" aria-hidden=\"true\"></i> --> </div>\n\t\t\t\t\t\t\t\t\t<div class=\"keyboard\" ng-if=\"!autonomous\"> </div>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"autonomous && language=='english'\"> AUTONOMOUS </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!autonomous && language=='english'\"> MANUAL </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"autonomous && language=='french'\"> AUTONOME </span>\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!autonomous && language=='french'\"> MANUEL </span>  \t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"batTemp\">\n\t\t\t\t\t\t\t\t\t<div class=\"connectbat\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"battery\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"batlev\"  ng-style=\"{width: battlevel+'%'}\">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"batconnect\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"therm\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"temperature\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"cercle\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"bluecercle\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"someRed\">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"thermometer\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"mercure\" ng-style=\"{height: mercurelevel}\"> \t\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"robotwaterres\">\n\t\t\t\t\t\t\t\t<div class=\"littlesplatchwhite\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"waterlevelbar\">\n\t\t\t\t\t\t\t\t\t<div class=\"waterlevelcont\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"waterlevel\" ng-style=\"{width: watlevel +'%'}\">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>"

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })

});


// WEBPACK FOOTER //
// app.0d7f98b8fe833bc42139.js